//@ts-nocheck

var guba_api = require("../guba/index");
var stock_info = require('../stock_info/web').default
var stock_info_new = require('../stock_info/newweb').default
var newzxg = require('../newzxg/web').default
import delayparams from "../url/delayQuote";
var bjTable = require('../quote_table/table').default
import hk_rule from '../hk_rule'

// var default_groupid = '' //自选股默认分组id
// newzxg.groupList().then(function(data){
//     // console.info(data)
//   default_groupid = data.result[0].gid
//   //初始化自选股状态
// //   if(data.default_group.includes(stock_market + '.' + stock_code)){
// //         $("#deletestock_btn").show()
// //         $("#addstock_btn").hide();
// //   }
// //   else{
// //         $("#deletestock_btn").hide()
// //         $("#addstock_btn").show();
// //   }
// })

newzxg.checkHasAdd(stock_market + '.' + stock_code).then(function(data){ 
  //初始化自选股状态
  if(data.result){
        $("#deletestock_btn").show()
        $("#addstock_btn").hide();
  }
  else{
        $("#deletestock_btn").hide()
        $("#addstock_btn").show();
  }
})


var CODE = window.stock_code;
var MK = window.stock_market;
var _market = getMarketSource();

var browser = navigator.userAgent.toLowerCase();
var isWx = false;
if (browser.indexOf("micromessenger") != -1 || browser.indexOf("qq/") != -1 || browser.indexOf("weibo") != -1) {
    isWx = true;
}

if(isPC()){
    // 如果PC则跳转网页版东财
    //window.location.href = 'https://quote.eastmoney.com/unify/r/' + MK + '.' + CODE
}

var HS_CODE_HS = "1",
    HS_CODE_SS = "0",
    HS_CODE_ZZ = "2", // 中证指数
    GG_CODE = "116",
    MG_CODE_NS = "105",
    MG_CODE_NJ = "106",
    MG_CODE_MJ = "107",
    YG_CODE_LD = "155",
    YG_CODE_LDGJ = "156",
    ZS_CODE_YB = "100",
    ZS_CODE_OTHER = "124",
    ZS_CODE_OTHER1 = "125",
    BK_CODE_NO = "90",
    CHOICE_ZS = '47',
    QIHUO_ZS = '159',  //东财期货指数
    ZSS_ZS = '223',  //郑商所指数
    FD_CODE = '153'; //粉单

var s_qh = ["8", "220", "101", "103", "104", "108", "109", "113", "134", "114", "115", "142", "225"];//期货
var s_wh = ["119", "120", "121", "133"];//外汇
var s_hj = ["122"];//黄金
var s_yy = ["111", "112", "102", "118"]; //原油
var s_qq = ["10","11", "221", "139" , "140" , '151', "163", "245", "226"];//期权
var s_newzs = ['159', '223']
var cy_timer;
var chart_type = "T1"

var isLogin = false,
    isRemind = false,
    isRefresh = true,
    isCN = true

var bjlmtArr = [
    [20,20,20,20],
    [20,20,20,20,20]
]

var bjOptions = {
    navtype:1,
    tabletype:0
}

if(!isWx){
    $('.open-inapp').show();
}
//判断是否该code为指数
function iszs() {
    if (MK == 47) {
        return true
    }

    if (MK == 159 || MK == 223) {
        return true
    }
    

    if (CODE.substr(0, 3) == "000" && MK == 1) {
        return true;
    }

    if (CODE.substr(0, 3) == "399" && MK == 0) {
        return true;
    }

    if (CODE.substr(0, 3) == "395" && MK == 0) {
        return true;
    }

    if (CODE.substr(0, 3) == "899" && MK == 0) {
        return true;
    }    
    return false;
}
window.iszs = iszs

//判断是否该code为期货
function isqh() {
    if (s_qh.indexOf(MK) > -1) {
        return true;
    } else {
        return false;
    }
}
window.isqh = isqh

//判断是否该code为外汇
function iswh() {
    if (s_wh.indexOf(MK) > -1) {
        return true;
    } else {
        return false;
    }
}
window.iswh = iswh
//判断是否该code为黄金
function ishj() {
    if (s_hj.indexOf(MK) > -1) {
        return true;
    } else {
        return false;
    }
}
window.ishj = ishj
//判断是否该code为黄金
function isyy() {
    if (s_yy.indexOf(MK) > -1) {
        return true;
    } else {
        return false;
    }
}
window.isyy = isyy
//判断是否该code为期权
function isqq() {
    if (s_qq.indexOf(MK) > -1) {
        return true;
    } else {
        return false;
    }
}
window.isqq = isqq
//判断是否该code为债券
function iszq() {
    if (MK == "1" && CODE.substr(0, 3) == "019") {
        return true;
    }
    if (MK == "1" && CODE.substr(0, 3) == "010") {
        return true;
    }
    if (MK == "1" && CODE.substr(0, 1) == "1") {
        return true;
    }
    if(_market?.f107 == 1 && _market?.f182 == 14){
        return false
    }

    if (MK == "1" && CODE.substr(0, 1) == "2") {
        return true;
    }
    return false;
}
window.iszq = iszq

// 判断该股票是否为债券 2021.09.10
function isBond(market,type,typeEx){
    // 返回值 1：深交所债券 2：深交所质押回购 3：上交所债券 4：上交所质押回购
    if((market == 0) && (type == 8)){
        if(typeEx == 14){
            return 2
        }else{
            return 1
        }
    }
    if((market == 1) && (type == 4)){
        if(typeEx == 14){
            return 4
        }else{
            return 3
        }
    }
    return false
}


function getCookie(a) {
    var c, d, b = document.cookie.split(";");
    for (c = 0; c < b.length; c++)
        if (d = b[c].split("="), d[0].replace(" ", "") == a)
            return unescape(decodeURI(d[1]));
    return ""
}

function getMarketSource() {
    var self = this
    var url = quotaConfig.host + quotaConfig.tPath + "?secid=" + MK + "." + CODE + "&ut=f057cbcbce2a86e2866ab8877db1d059&fields=f107,f111,f181,f182"+delayparams
    var xhr = $.ajax({
        url: url,
        async: false
    });
    var data = JSON.parse(xhr.responseText)
    return data.data
}

function mpSort(arr){
    for(var j=0;j<arr.length-1;j++){
    //两两比较，如果前一个比后一个大，则交换位置。
       for(var i=0;i<arr.length-1-j;i++){
            if(arr[i]>arr[i+1]){
                var temp = arr[i];
                arr[i] = arr[i+1];
                arr[i+1] = temp;
            }
        } 
    }
}

//注册图表tab切换事件
function chartTabEvent() {

    $("#chartTab li").click(function () {
        $("#chartTab li").removeClass()
        this.setAttribute("class", "active")
        //imgt为undefined特殊处理
        if (this.attributes["imgt"] == undefined) {
            if (this.attributes["imgtp"] == undefined) {
                //点的默认moretime,当前展开则收回，当前收回则展开
                if ($("#selectK").hasClass("selector-items hide")) {
                    $("#selectK").removeClass();
                    $("#selectK").addClass("selector-items");

                    if ($("#moretime").text().replace(/(^\s*)|(\s*$)/g, "") == "分钟") {
                        $("#selectK li").siblings().removeClass();
                        $("#selectK li").eq(0).addClaass("selected");
                    } else {
                        $("#selectK li").siblings().removeClass();
                        $.each($("#selectK li"), function (i) {
                            if ($(this).text().replace(/(^\s*)|(\s*$)/g, "") == $("#moretime").text().replace(/(^\s*)|(\s*$)/g, "")) {
                                $(this).addClass("selected");
                            }
                        })
                    }
                } else {
                    $("#selectK").removeClass();
                    $("#selectK").addClass("selector-items hide");
                }
            } else {
                //点的5，15，30， 60
                $("#moretime").text($(this).text());
                $("#liChart1").hide();
                $("#liChart2").show();
                //drawKLine(this.attributes["imgtp"].value);
                drawKChart(this.attributes["imgtp"].value)
            }
            return;
        } else {
            $("#selectK").removeClass();
            $("#selectK").addClass("selector-items hide");
        }
        var type = this.attributes["imgt"].value;
        chart_type = type
        if (type == "T1") {
            $("#liChart1").show();
            $("#liChart2").hide();
            $(".right-p").css('display','block');
            $(".left-p").css("width","60%");
            //drawFS(type);
            drawTimeChart(type)
        }else if(type == "T5"){
            $("#liChart1").show();
            $("#liChart2").hide();
            $(".right-p").css('display','none');
            $(".left-p").css("width","100%");
            //drawFS(type);
            drawTimeChart(type)
        }
        else {
            $("#liChart1").hide();
            $("#liChart2").show();
            //drawKLine(type);
            drawKChart(type)
        }
    });

    $("#stock-infos-tabs li").click(function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");

        $.each($("#stock-infos-list").find('li'), function (i) {
            $(this).hide();
            $(this).removeClass("active");
        })

        //切换tab初始化不展示
        $("#js_xw_final").hide();
        $("#js_gg_final").hide();
        $("#js_yb_final").hide();
        $("#js_gb_final").hide();
        $("#js_loadmore11").hide();
        $("#js_loadmore21").hide();
        $("#js_xw_more").hide();
        $("#js_yb_more").hide();
        $("#js_gg_more").hide();
        $("#js_gb_nodata").hide();
        $("#js_xw_nodata").hide();
        $("#js_yb_nodata").hide();
        $("#js_gg_nodata").hide();
        $("#onLoadingUI_gb").show();
        $("#onLoadingUI_xw").show();
        $("#onLoadingUI_yb").show();
        $("#onLoadingUI_gg").show();

        page = 1;
        page1 = 1;
        pagenews = 1;
        pagenotice = 1;
        pageyb = 1;

        $("#ulgbContainer").html("");
        $("#ulxwContainer").html("");
        $("#ulggContainer").html("");
        $("#ulybContainer").html("");

        if ($(this).data("tab") == "gb") {
            $.each($("#stock-infos-list").find('li'), function (i) {
                if ($(this).data("tab") == "gb") {
                    $(this).show();
                    $(this).addClass("active");
                    loadGb(MK,CODE)
                }
            })
        } else if ($(this).data("tab") == "cfg") {
            $.each($("#stock-infos-list").find('li'), function (i) {
                if ($(this).data("tab") == "cfg") {
                    $(this).show();
                    $(this).addClass("active");
                }
            })
        } else if ($(this).data("tab") == "zj") {
            $.each($("#stock-infos-list").find('li'), function (i) {
                if ($(this).data("tab") == "zj") {
                    $(this).show();
                    $(this).addClass("active");
                }
            })

            $.each($("#chartContainer").find('li'), function (i) {
                $(this).show();
            });

            $.each($("#five_zjl").find('li'), function (i) {
                $(this).show();
            })

        } else if ($(this).data("tab") == "xw") {
            $.each($("#stock-infos-list").find('li'), function (i) {
                if ($(this).data("tab") == "xw") {
                    $(this).show();
                    $(this).addClass("active");
                }
            })
            _loadnews(1, 0);
        } else if ($(this).data("tab") == "yb") {
            $.each($("#stock-infos-list").find('li'), function (i) {
                if ($(this).data("tab") == "yb") {
                    $(this).show();
                    $(this).addClass("active");
                }
            })
            //loadnews(1, 3);
            _loadnews(1,1)
        } else if ($(this).data("tab") == "cw") {
            if (_market.f107 == 0 || _market.f107 == 1) { 
                // 沪深
                if ((_market.f107 == 1 && _market.f111 == 9) || (_market.f107 == 0 && _market.f111 == 10)) {
                    // 沪深场内基金
                    location.href = "https://emh5.eastmoney.com/hscnf10/html/index.html?fc=" + CODE + getstockkind(MK) + "&color=w#/index"
                } else if ((_market.f107 == 1 && _market.f182 == 11) || (_market.f107 == 0 && _market.f182 == 11)) {
                    // 沪深可转债
                    location.href = "https://emh5.eastmoney.com/change/index.html?fc=" + CODE + getstockkind(MK) + "&color=w#/jbxx"
                } else if ((_market.f107 == 0) && (_market.f181 & 2048)){
                    // 北交所
                    location.href = "https://emh5.eastmoney.com/SanBan/html/index.html?fc=" + CODE + ".BJ&color=w#/cwfx"
                } else if (_market.f107 == 0 && _market.f111 == 81) {
                    // 三板
                    location.href = "https://emh5.eastmoney.com/SanBan/html/index.html?fc=" + CODE + ".OC&color=w#/cwfx"
                } else {
                    // 一般沪深
                    location.href = "https://emh5.eastmoney.com/html/?fc=" + CODE + getstockkind(MK) + "&color=w#/cwfx"
                }
            } else if (_market.f107 == 105 || _market.f107 == 106 || _market.f107 == 107) {
                // 美股
                var houzhui = "";
                if (_market.f107 == 107) {
                    houzhui = ".A";
                } else if (_market.f107 == 106) {
                    houzhui = ".N";
                } else if (_market.f107 == 105) {
                    houzhui = ".O";
                }
                location.href = "https://emh5.eastmoney.com/us/index.html?fc=" + CODE + houzhui + "&color=w#/cwfx"
            } else if (_market.f107 == 116) {
                //港股
                location.href = "https://emh5.eastmoney.com/HK/index.html?fc=" + CODE + "&color=w#/cwfx"
            } else if (_market.f107 == 155 || _market.f107 == 156) {
                //英股
                location.href = "https://emh5.eastmoney.com/uk/index.html?fc=" + CODE + "&color=w#/cwfx"
            } else if (_market.f107 == 150) {
                //场外基金
                location.href = `https://emh5.eastmoney.com/jjf10/index.html?fc=${self.code}.OF&color=w#/index`
            } else if (_market.f107 == 113 || _market.f107 == 114 || _market.f107 == 115 || _market.f107 == 118 || _market.f107 == 142 || _market.f107 == 225) {
                //国内期货 资料 按钮隐藏
            }

            // 内嵌财务标签
            // $.each($("#stock-infos-list").find('li'), function (i) {
            //     if ($(this).data("tab") == "cw") {
            //         if(cwurl){
            //             var cwhtml = "<iframe id='cwiframe' width='100%' height='1500px' src='" + cwurl + "' scrolling='no' frameborder='0'></iframe>"
            //             $('#cwdiv').html(cwhtml)
            //             $(this).show();
            //             $(this).addClass("active");
            //             window.addEventListener('message', function(e){
            //                 $('#cwiframe').height(e.data.height)
            //             })
            //         }
            //     }
            // })
        } else if ($(this).data("tab") == "gg") {
            $.each($("#stock-infos-list").find('li'), function (i) {
                if ($(this).data("tab") == "gg") {
                    $(this).show();
                    $(this).addClass("active");
                }
            })
            //loadnews(1, 2);
            _loadnews(1, 2);
        } else if ($(this).data("tab") == "zl") {
            if (_market.f107 == 0 || _market.f107 == 1) {
                // 沪深
                if ((_market.f107 == 1 && _market.f111 == 9) || (_market.f107 == 0 && _market.f111 == 10)) {
                    //沪深场内基金
                    location.href = "https://emh5.eastmoney.com/hscnf10/html/index.html?fc=" + CODE + getstockkind(MK) + "&color=w#/index"
                } else if ((_market.f107 == 1 && _market.f182 == 11) || (_market.f107 == 0 && _market.f182 == 11)) {
                    //沪深可转债
                    location.href = "https://emh5.eastmoney.com/change/index.html?fc=" + CODE + getstockkind(MK) + "&color=w#/jbxx"
                } else if ((_market.f107 == 0) && (_market.f181 & 2048)){
                    // 北交所
                    location.href = "https://emh5.eastmoney.com/SanBan/html/index.html?fc=" + CODE + ".BJ&color=w#/cpbd"
                } else if (_market.f107 == 0 && _market.f111 == 81) {
                    //三板
                    location.href = "https://emh5.eastmoney.com/SanBan/html/index.html?fc=" + CODE + ".OC&color=w#/cpbd"
                } else {
                    //一般沪深
                    location.href = "https://emh5.eastmoney.com/html/?fc=" + CODE + getstockkind(MK) + "&color=w#/cpbd"
                }
            } else if (_market.f107 == 105 || _market.f107 == 106 || _market.f107 == 107 || _market.f107 == 153) {
                // 美股
                var houzhui = "";
                if (_market.f107 == 107) {
                    houzhui = ".A";
                } else if (_market.f107 == 106) {
                    houzhui = ".N";
                } else if (_market.f107 == 105) {
                    houzhui = ".O";
                } else if (_market.f107 == 153) {
                    houzhui = ".F";
                }
                location.href = "https://emh5.eastmoney.com/us/index.html?fc=" + CODE + houzhui + "&color=w#/cpbd"
            } else if (_market.f107 == 116) {
                //港股
                location.href = "https://emh5.eastmoney.com/HK/index.html?fc=" + CODE + "&color=w#/cpbd"
            } else if (_market.f107 == 155 || _market.f107 == 156) {
                //英股
                location.href = "https://emh5.eastmoney.com/uk/index.html?fc=" + CODE + "&color=w#/cpbd"
            } else if (_market.f107 == 150) {
                //场外基金
                location.href = `https://emh5.eastmoney.com/jjf10/index.html?fc=${self.code}.OF&color=w#/index`
            } else if (_market.f107 == 113 || _market.f107 == 114 || _market.f107 == 115 || _market.f107 == 118 || _market.f107 == 142 || _market.f107 == 225) {
                //国内期货 资料 按钮隐藏
            }
        } else if ($(this).data("tab") == "bj") {
            $.each($("#stock-infos-list").find('li'), function (i) {
                if ($(this).data("tab") == "bj") {
                    $(this).show();
                    $(this).addClass("active");
                }
            })
        }
    })

    //股吧分享关闭
    $("#em_share_1,#em_share_2").click(function () {
        $(this).hide();
    })

    //上证指数浮层
    $("#indexbox").click(function () {
        if ($("#js_szzs").css("display") == "none") {
            drawFSNew();
            $("#indexbox i").css("border-bottom", "0px");
            $("#indexbox i").css("border-top", "0.5rem solid rgb(100, 100, 100)");
            $("#js_szzs").show();
        } else {
            $("#js_szzs").hide();
            $("#indexbox i").css("border-top", "0px");
            $("#indexbox i").css("border-bottom", "0.5rem solid rgb(100, 100, 100)");
        }
        if($('.stock-more-nav').css('display') != 'none'){
            $('.stock-more-nav').css('display','none')
            $('.stock-layer').hide()
        }
    })

    //分享
    $('#stockShare').click(function(){
        if($('.stock-more-nav').css('display') != 'none'){
            $('.stock-more-nav').css('display','none')
            $('.stock-layer').hide()
        }
        sharestock()
    })

    //分享微信，朋友圈，QQ空间，微博点击事件
    $("#js_share_jh li").click(function () {
        var thistext = $.trim($(this).text())
        if (thistext == "微信" || thistext == "朋友圈") {
            $("#em_share_2").hide();
            $("#em_share_1").show();
        } else if (thistext == "QQ空间") {
            location.href = "http://qzs.qzone.qq.com/open/connect/widget/mobile/qzshare/index.html?url=https://emwap.eastmoney.com/quota/stock/index/" + $("#stockCode").val() + getstockkind(MK, "1") + "&appkey=801004939&title=" + $("#js_stockname").val(); + "(" + $("#stockCode").val() + ")最新价格_行情_走势图-东方财富&desc=" + $("#js_stockname").val(); + "(" + $("#stockCode").val() + ")股价走势&imageUrl=https://emfed.eastmoney.com/public/resource/img/wechatlogo.png&source=东方财富移动版&site=http://wap.eastmoney.com";

            //var evt = $.Event('keydown', { keyCode: 13 });
            //$(this).trigger(evt);
            //return false;
        } else if (thistext == "微博") {
            switch ($("#js_share_tab").val()) {
                case "guba":
                    location.href = "https://service.weibo.com/widget/public/login.php?source=share&backurl=https://service.weibo.com/share/mobile.php?url=" + $("#js_share_url").val() + "&appkey=3050999700&title=" + $("#js_share_content").val() + "&pic=https://emfed.eastmoney.com/public/resource/img/wechatlogo.png&source=东方财富移动版&sourceUrl=http://wap.eastmoney.com&frefer=";
                    break;
                case "stock":
                    location.href = "https://service.weibo.com/widget/public/login.php?source=share&backurl=https://service.weibo.com/share/mobile.php?url=https://emwap.eastmoney.com/quota/stock/index/" + $("#stockCode").val() + "&appkey=3050999700&title=" + $("#stockCode").val() + "最新价格_行情_走势图-东方财富&pic=https://emfed.eastmoney.com/public/resource/img/wechatlogo.png&source=东方财富移动版&sourceUrl=http://wap.eastmoney.com&frefer=";
                    break;
            }
        }
    })

    //报价签一级菜单切换事件
    $('#stock-bj-nav dd').click(function(){
        $("#stock-bj-nav dd").removeClass();
        $(this).addClass("active");
        if($(this).data("tab") == 1){
            $('.stock-bj-declare').show();
            $('.stock-bj-deal').hide();
        }
        if($(this).data("tab") == 2){
            $('.stock-bj-declare').hide();
            $('.stock-bj-deal').show();
            if(!!!$('#deal-bj-table').html()){
                bjOptions.navtype = 2;
                bjOptions.tabletype = 0;
                loadBJ(MK,CODE,2,0);
            }
        }
    })

    //报价签二级菜单切换事件
    $('#stock-bj-declare-nav dd').click(function(){
        $("#stock-bj-declare-nav dd").removeClass();
        $(this).addClass("bj-tab-active");
        bjOptions.navtype = 1;
        bjOptions.tabletype = $(this).data("tab");
        loadBJ(MK,CODE,1,$(this).data("tab"));
    })

    //报价签二级菜单切换事件
    $('#stock-bj-deal-nav dd').click(function(){
        $("#stock-bj-deal-nav dd").removeClass();
        $(this).addClass("bj-tab-active");
        bjOptions.navtype = 2;
        bjOptions.tabletype = $(this).data("tab");
        loadBJ(MK,CODE,2,$(this).data("tab"));
    })
}
//分享打开
function sharecontent(type, url, content) {
    $("#js_share_tab").val(type);
    $("#js_share_url").val(url);
    $("#js_share_content").val(content);

    $("#em_share_1").hide();
    $("#em_share_2").show();
}

window.sharecontent = sharecontent

function commentguba(post_id) {
    location.href = "http://mguba.eastmoney.com/mguba/newreply/1/" + post_id;
}

window.commentguba = commentguba

function opendetail(type, id) {
    switch (type) {
        case "guba":
            location.href = "http://mguba.eastmoney.com/mguba/article/0/" + id;
            break;
        case "gg":
            location.href = "http://mguba.eastmoney.com/mguba/article/3/" + id;
            break;
        case "yb":
            location.href = "http://mguba.eastmoney.com/mguba/article/2/" + id;
            break;
        case "xw":
            location.href = "https://wap.eastmoney.com/a/" + id + ".html";
            break;
    }
}

window.opendetail = opendetail

function stockmore(){
    if($('.stock-more-nav').css('display') == 'none'){
        $('.stock-more-nav').css('display','block')
        $('.stock-layer').show()
    }else{
        $('.stock-more-nav').css('display','none')
        $('.stock-layer').hide()
    }

    if ($("#js_szzs").css("display") != "none") {
        $("#js_szzs").hide();
        $("#indexbox i").css("border-top", "0px");
        $("#indexbox i").css("border-bottom", "0.5rem solid rgb(100, 100, 100)");
    }
}

window.stockmore = stockmore

function goAppStock(){
    var market,code
    if(MK == 0){
        //深圳
        market = "sz"
    }else if(MK == 1){
        market = "sh"
    }

    code = CODE

    if(market){
        location.href = "https://emwap.eastmoney.com/h52n?type=stock&code="+code +"&market=" + market
    }
}

window.goAppStock = goAppStock

// 新版研报公告跳转地址 2020.08.05

function opendetailnew(type, id) {

    var _CODE = window.stock_code;
    var _MK = window.stock_market;
    
    switch (type) {
        case "gg":
            location.href = "https://np-info.eastmoney.com/wap/notice/?infocode=" + id;
            break;
        case "yb":
            location.href = "https://wap.eastmoney.com/report/" + id + ".html?code=" + _CODE + "&market=" + _MK;
            break;
        case "xw":
            location.href = "https://wap.eastmoney.com/a/" + id + ".html";
            break;
    }
}

window.opendetailnew = opendetailnew

function sharestock() {
    sharecontent('stock', location.href, "");
}

window.sharestock = sharestock

// 数字 num 保留指定 n 个小数位
function toFix(num, n) {
    var f = parseFloat(String(num));
    if (isNaN(f)) {
      return '-';
    }
    var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
    if (n == 0) {
      return f
    } else {
      var s = f.toString();
      var rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + n) {
        s += '0';
      }
      return s;
    }
}

//分时图表绘制
function drawFS(type) {
    if (MK == MG_CODE_NS || MK == MG_CODE_NJ || MK == MG_CODE_MJ || MK == ZS_CODE_YB || MK == QIHUO_ZS || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1 || iszs() || MK == BK_CODE_NO || isqh() || iswh() || ishj() || isyy() || isqq() || iszq() || MK == FD_CODE || MK == HS_CODE_ZZ) {
        $(".left-p").width("100%");
        $(".right-p").remove();
    }

    //调用绘图方法
    var chart = new EmchartsMobileTime(Object.assign({
        container: "chart1",
        code: window.market + "." + window.code,
        width: $("#chart1").width(),
        height: $(".charts").height(),
        dpr: 2,
        showVMax: true,
        type: type
    }, null))
    chart.draw()
}

// 分时图绘图新版
function drawTimeChart(type) {
    if (MK == MG_CODE_NS || MK == MG_CODE_NJ || MK == MG_CODE_MJ || MK == ZS_CODE_YB || MK == QIHUO_ZS || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1 || iszs() || MK == BK_CODE_NO || isqh() || iswh() || ishj() || isyy() || isqq() || iszq() || MK == FD_CODE || MK == HS_CODE_ZZ) {
        $(".left-p").width("100%");
        $(".right-p").remove();
    }

    var nday = type == "T1" ? 1 : 5
    //调用绘图方法
    var chart = new mobilequotechart({
        id: '#chart1', // Canvas画布所在的父元素的ID
        code: window.market + "." + window.code, // 股票代码
        ut: 'f057cbcbce2a86e2866ab8877db1d059', // 接口请求参数ut
        width: $("#chart1").width(), // Canvas画布的宽度，如果没传则继承父元素宽度
        height: $(".charts").height(), // Canvas画布的高度，如果没传则继承父元素高度
        ndays: nday, // 分时图时，所展示的分时天数，当 n 的值大于1时，盘前设置则无效
        iscr: sessionStorage.getItem("fsstatus") == '1' ? true : false, // 分时图是否展示盘前数据
        iscca: sessionStorage.getItem("fsstatus") == '2' ? true : false, // 分时图是否展示盘后数据
        cursor: true, // 是否使用交互功能
        simplemode: true, // 是否开启简单配置模式
        simpletype: 'time', // 简单配置模式图的类型 time、kline分别对应分时图和K线图
        cursorCallback: function (data, index, state) {
            // data 是数据 ，index是当前数据的位置，state 是滑动状态
            showFSData(data, index, state)
        }
    })
    chart.init()
}

//分时图手指滑动时，顶部数据显示
function showFSData(data, index, state) {
    var json = JSON.parse(sessionStorage.getItem("data"))
    var bond = isBond(json.data.f107,json.data.f111,json.data.f182)
    if (state == 'start' || state == 'move') {   
        var _color = formartColorNew(data.trends[index].price,data.prePrice)
        var _zs = formartDataNew(json.data.f60,json.data.f59,json.data.f59)
        $('#stock_uk_top').hide()
        $('#stock_bond_top').hide()
        var top_tlp,bottom_tlp
        if(isqh()){
            top_tlp = `
            <div class="top-p">
                <div id="inum">
                    <p class="stock-value ${_color}" style="font-size: 2rem;">
                        ${data.trends[index].price}
                    </p>
                    <p>
                        <span class="${_color}">${toFix((data.trends[index].price-data.prePrice)/data.prePrice*100,2)}%</span><span class="${_color}">${toFix(data.trends[index].price-data.prePrice,data.decimal)}</span>
                    </p>
                </div>
                <div>
                    <div class="row">
                        <p>
                            <span>今开</span><span class="${formartColorNew(json.data.f46,json.data.f60)}">${formartDataNew(json.data.f46,json.data.f59,json.data.f59)}</span>
                        </p>
                        <p>
                            <span>最高</span><span class="${formartColorNew(json.data.f44,json.data.f60)}">${formartDataNew(json.data.f44,json.data.f59,json.data.f59)}</span>
                        </p>
                        <p>
                            <span>最低</span><span class="${formartColorNew(json.data.f45,json.data.f60)}">${formartDataNew(json.data.f45,json.data.f59,json.data.f59)}</span>
                        </p>
                    </div>
                    <div class="row">
                        <p>
                            <span>总手</span><span>${conversion(json.data.f47,'calc',2)}</span>
                        </p>
                        <p>
                            <span>持仓</span><span>${conversion(json.data.f133,'calc',2)}</span>
                        </p>
                        <p>
                            <span>日增</span><span class="${formartColorNew(json.data.f133-json.data.f132,0)}">${formateToSub(json.data.f133,json.data.f132)}</span>
                        </p>
                    </div>
                </div>
            </div>`
        }else if(isqq()){
            top_tlp = `
            <div class="top-p">
                <div id="inum">
                    <p class="stock-value ${_color}" style="font-size: 2rem;">
                        ${data.trends[index].price}
                    </p>
                    <p>
                        <span class="${_color}">${toFix((data.trends[index].price-data.prePrice)/data.prePrice*100,2)}%</span><span class="${_color}">${toFix(data.trends[index].price-data.prePrice,data.decimal)}</span>
                    </p>
                </div>
                <div>
                    <div class="row">
                        <p>
                            <span>今开</span><span class="${formartColorNew(json.data.f46,json.data.f60)}">${formartDataNew(json.data.f46,json.data.f59,json.data.f59)}</span>
                        </p>
                        <p>
                            <span>最高</span><span class="${formartColorNew(json.data.f44,json.data.f60)}">${formartDataNew(json.data.f44,json.data.f59,json.data.f59)}</span>
                        </p>
                        <p>
                            <span>最低</span><span class="${formartColorNew(json.data.f45,json.data.f60)}">${formartDataNew(json.data.f45,json.data.f59,json.data.f59)}</span>
                        </p>
                    </div>
                    <div class="row">
                        <p>
                            <span>总手</span><span>${conversion(json.data.f47,'calc',2)}</span>
                        </p>
                        <p>
                            <span>金额</span><span>${conversion(json.data.f48,'calc',2)}</span>
                        </p>
                        <p>
                            <span>量比</span><span>${formartDataNew(json.data.f50,json.data.f152,json.data.f152)}</span>
                        </p>
                    </div>
                </div>
            </div>`
        }else if(bond && json.data.f182 != 11){
            top_tlp = ``
        }else if(json.data.f182 == 98){
            //债券指数
            top_tlp = ``
        }else{
            top_tlp = `
            <div class="top-p">
                <div id="inum">
                    <p class="stock-value ${_color}" style="font-size: 2rem;">
                        ${data.trends[index].price}
                    </p>
                    <p>
                        <span class="${_color}">${toFix((data.trends[index].price-data.prePrice)/data.prePrice*100,2)}%</span><span class="${_color}">${toFix(data.trends[index].price-data.prePrice,data.decimal)}</span>
                    </p>
                </div>
                <div>
                    <div class="row">
                        <p>
                            <span>今开</span><span class="${formartColorNew(json.data.f46,json.data.f60)}">${formartDataNew(json.data.f46,json.data.f59,json.data.f59)}</span>
                        </p>
                        <p>
                            <span>最高</span><span class="${formartColorNew(json.data.f44,json.data.f60)}">${formartDataNew(json.data.f44,json.data.f59,json.data.f59)}</span>
                        </p>
                        <p>
                            <span>最低</span><span class="${formartColorNew(json.data.f45,json.data.f60)}">${formartDataNew(json.data.f45,json.data.f59,json.data.f59)}</span>
                        </p>
                    </div>

                    <div class="row">
                        <p>
                            <span>换手</span><span>${toFix(data.trends[index].amount/json.data.f117*100,3) == '-' ? '-' : (toFix(data.trends[index].amount/json.data.f117*100,3) + '%')}</span>
                        </p>
                        <p>
                            <span>总手</span><span>${conversion(data.trends[index].volume,'calc',2)}</span>
                        </p>
                        <p>
                            <span>金额</span><span>${conversion(data.trends[index].amount,'calc',2)}</span>
                        </p>
                    </div>
                </div>
            </div>
        `
        }
        if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS||iswh()||isyy()||ishj()){
            if(bond == 1 && json.data.f182 != 11){
                bottom_tlp = `
                <div id="bondul" class="bond-container">
                <div class="bond-container-left">
                    <div>
                        <p class="${_color}">${data.trends[index].price}</p>
                        <p class="bond-precent">
                            <span class="${_color}">${toFix((data.trends[index].price-data.prePrice)/data.prePrice*100,2)}%</span>
                            <span class="${_color}">${toFix(data.trends[index].price-data.prePrice,data.decimal)}</span>
                        </p>
                    </div>
                </div>
                <div class="bond-container-right">
                    <ul>
                        <li>
                            <p>总成交量</p>
                            <p>${conversion(json.data.f47,'calc',2)}</p>
                        </li>
                        <li>
                            <p>最新YTM</p>
                            <p>${json.data.f703 == "-"?"--":formartDataNew(json.data.f703,json.data.f154,json.data.f152)+"%"}</p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p>总成交额</p>
                            <p>${conversion(json.data.f48,'calc',2)}</p>
                        </li>
                        <li>
                            <p>最近成交方式</p>
                            <p>${returnTransactionMode(json.data.f706)}</p>
                        </li>
                    </ul>
                </div>
                <div class="bond-more">
                    <i class="bond-more-button"></i>
                </div>
            </div>
                `
            }else if(bond == 3 && json.data.f182 != 11){
                bottom_tlp = `
                <div id="bondul" class="bond-container">
                <div class="bond-container-left">
                    <div>
                        <p class="${_color}">${data.trends[index].price}</p>
                        <p class="bond-precent">
                            <span class="${_color}">${toFix((data.trends[index].price-data.prePrice)/data.prePrice*100,2)}%</span>
                            <span class="${_color}">${toFix(data.trends[index].price-data.prePrice,data.decimal)}</span>
                        </p>
                    </div>
                </div>
                    <div class="bond-container-right">
                        <ul>
                            <li>
                                <p>成交量</p>
                                <p>${conversion(json.data.f47,'calc',2)}</p>
                            </li>
                            <li>
                                <p>最新YTM</p>
                                <p>${json.data.f703=="-"?"--":formartDataNew(json.data.f703,json.data.f154,json.data.f152)+"%"}</p>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <p>成交额</p>
                                <p>${conversion(json.data.f48,'calc',2)}</p>
                            </li>
                            <li>
                                <p>涨跌BP</p>
                                <p>${json.data.f704=="-"?"--":formartDataNew(json.data.f704/100,json.data.f152,json.data.f152)}</p>
                            </li>
                            
                        </ul>
                    </div>
                    <div class="bond-more">
                        <i class="bond-more-button"></i>
                    </div>
                </div>`
            }else if((bond == 2 || bond == 4) && json.data.f182 != 11){
                bottom_tlp = `
                <div id="bondul" class="bond-container">
                <div class="bond-container-left">
                    <div>
                        <p class="${_color}">${data.trends[index].price}</p>
                        <p class="bond-precent">
                            <p class="${_color}" style="text-align: center;">${formartDataNew((data.trends[index].price - _zs)*100,0,2) + 'BP'}</p>
                        </p>
                    </div>
                </div>
                <div class="bond-container-right">
                    <ul>
                        <li>
                            <p>加权平均</p>
                            <p>${formartDataNew(json.data.f71,json.data.f59,json.data.f59)}</p>
                        </li>
                        <li>
                            <p>加权涨跌</p>
                            <p>${json.data.f705 == '-' ? '-' : formartDataNew(json.data.f705,json.data.f152,json.data.f152) +' BP'}</p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p>成交量</p>
                            <p>${conversion(json.data.f47,'calc',2)}</p>
                        </li>
                        <li>
                            <p>昨加权</p>
                            <p>${formartDataNew(json.data.f721,json.data.f59,json.data.f59)}</p>
                        </li>
                    </ul>
                </div>
                <div class="bond-more">
                    <i class="bond-more-button"></i>
                </div>
            </div>
                `
            }else if(bond && json.data.f182 == 11){
                // 可转债
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span>昨收</span><span>${formartDataNew(json.data.f60,json.data.f59,json.data.f59)}</span></p>
                    <p>
                        <span class="stock-span">转股价值</span><span>${formartDataNew(json.data.f427,json.data.f154,json.data.f152)}</span>
                    </p>
                    <p>
                        <span class="stock-span">转股溢价</span><span class="${formartColorNew(json.data.f428,0)}">${json.data.f428 == "-"?"--":formartDataNew(json.data.f428,json.data.f152,json.data.f152)+"%"}</span>
                    </p>
                    <p>
                        <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore('zq')">更多</a>
                    </p>
                </div>
                <div class="bottom-extra" onclick="loadmorezg('${json.data.f262}')">
                    <p>
                        <span>正股报价:</span>
                        &nbsp;&nbsp;&nbsp;
                        <span>${json.data.f264}</span>
                        &nbsp;&nbsp;&nbsp;
                        <span class="${formartColorNew(json.data.f267,json.data.f266)}">${json.data.f267=="-"?"--":formartDataNew(json.data.f267,json.data.f265,json.data.f265)}</span>
                        &nbsp;&nbsp;&nbsp;
                        <span class="${formartColorNew(json.data.f267,json.data.f266)}">${json.data.f268=="-"?"--":formatAffix(formartDataNew(json.data.f268,json.data.f265,json.data.f265),"+","%")}</span>
                    </p>
                    <p style="margin-right: 10px;">
                        <span>&nbsp;</span><a>
                            <i class="arrow-right-new"></i>
                        </a>
                    </p>
                </div>
                `
            }else{
                if(json.data.f182 == 98){
                    bottom_tlp = `
                                <div id="bondul" class="bond-container">
                                <div class="bond-container-left">
                                    <div>
                                        <p class="${_color}">${data.trends[index].price}</p>
                                        <p class="bond-precent">
                                            <span class="${_color}">${toFix((data.trends[index].price-data.prePrice)/data.prePrice*100,2)}%</span>
                                            <span class="${_color}">${toFix(data.trends[index].price-data.prePrice,data.decimal)}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="bond-container-right">
                                    <ul>
                                        <li>
                                            <p>成交量</p>
                                            <p>${conversion(json.data.f47,'calc',2)}</p>
                                        </li>
                                        <li>
                                            <p>成交额</p>
                                            <p>${conversion(json.data.f48,'calc',2)}</p>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            <p>成交笔数</p>
                                            <p>${conversion(json.data.f296,'calc',2)}</p>
                                        </li>
                                        <li>
                                            <p>昨收</p>
                                            <p>${formartDataNew(json.data.f60,json.data.f59,json.data.f59)}</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="bond-more">
                                    <i class="bond-more-button"></i>
                                </div>
                            </div>
                        `
                } else {           
                    bottom_tlp = `
                    <div class="bottom-p">
                        <p><span>总值</span><span>${conversion(json.data.f116,'calc',2)}</span></p>
                        <p>
                            <span>流值</span><span>${conversion(json.data.f117,'calc',2)}</span>
                        </p>
                        <p>
                            <span>市盈<sup>TTM</sup></span><span>${formartDataNew(json.data.f164,json.data.f152,2)}</span>
                        </p>
                        <p>
                            <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore()">更多</a>
                        </p>
                    </div>
                    `
                }
            }
        }else if(MK == GG_CODE||MK == YG_CODE_LD || MK == YG_CODE_LDGJ){
            bottom_tlp = `
            <div class="bottom-p">
                <p><span>总值</span><span>${conversion(json.data.f116,'calc',2)}</span></p>
                <p>
                    <span>流值</span><span>${conversion(json.data.f117,'calc',2)}</span>
                </p>
                <p>
                    <span>市盈</span><sup>TTM</sup><span>${formartDataNew(json.data.f164,json.data.f152,2)}</span>
                </p>
                <p>
                    <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore()">更多</a>
                </p>
            </div>
            `
        }else if(MK == MG_CODE_NS || MK == MG_CODE_NJ || MK == MG_CODE_MJ ||MK == FD_CODE){
            bottom_tlp = `
            <div class="bottom-p">
                <p><span>52周高</span><span>${formartDataNew(json.data.f174,json.data.f152,2)}</span></p>
                <p>
                    <span>52周低</span><span>${formartDataNew(json.data.f175,json.data.f152,2)}</span>
                </p>
                <p>
                    <span>市盈</span><span>${formartDataNew(json.data.f164,json.data.f152,3)}</span>
                </p>
                <p>
                    <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                </p>
            </div>
            `
        }else if(MK == ZS_CODE_YB || MK == QIHUO_ZS || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1){
            bottom_tlp = `
            <div class="bottom-p">
                <p><span>昨收</span><span>${formartDataNew(json.data.f60,json.data.f59,2)}</span></p>
                <p></p><p></p><p></p>
            </div>
            `
        }else if(MK == BK_CODE_NO){
            bottom_tlp = `
            <div class="bottom-p">
                <p><span>涨家数</span><span>${json.data.f113}</span></p>
                <p><span>平家数</span><span>${json.data.f115}</span></p>
                <p><span>跌家数</span><span>${json.data.f114}</span></p>
                <p>
                    <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                </p>
            </div>
            `
        }else if(isqh()){
            bottom_tlp = `
            <div class="bottom-p">
                <p><span>结算</span><span class="${formartColorNew(json.data.f131-json.data.f130,0)}">${formartDataNew(json.data.f131,json.data.f59,json.data.f59)}</span></p>
                <p><span>昨结</span><span>${formartDataNew(json.data.f130,json.data.f59,json.data.f59)}</span></p>
                <p><span></span><span></span></p>
                <p>
                    <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                </p>
            </div>
            `
        }else if(isqq()){
            bottom_tlp = `
            <div class="bottom-p">
                <p><span>昨收</span><span>${formartDataNew(json.data.f60,json.data.f59,json.data.f59)}</span></p>
                <p>
                    <span>外盘</span><span class="red">${formartDataNew(json.data.f49,'calc',2)}</span>
                </p>
                <p>
                    <span>内盘</span><span class="green">${formartDataNew(json.data.f161,'calc',2)}</span>
                </p>
                <p></p>
            </div>
            `
        }
        if((bond && json.data.f182 != 11) || json.data.f182 == 98){
            var _html = `${top_tlp}${bottom_tlp}`
            $('#stock_bond_top').hide()
            $('#stock_bond_chart').html(_html)
            $('#stock_bond_chart').show()
        }else{
            $('#stock_chart_top').html(`<div id="snapul">${top_tlp}${bottom_tlp}</div>`)
            $('#stock_chart_top').show()
        }
        
        
    }
    if (state == 'end') {
        $('#stock_chart_top').hide()
        $('#stock_bond_chart').hide()
        if((bond && json.data.f182 != 11) || json.data.f182 == 98){
            $('#stock_bond_top').show()
        }else{
            $('#stock_uk_top').show()
        }
    }
}


//K线图表绘制
function drawKLine(type) {

    var chartK = new EmchartsMobileK(Object.assign({
        container: 'chart2',
        code: window.market + "." + window.code,
        width: $(".charts").width(),
        height: $(".charts").height(),
        dpr: 2,
        showVMark: true,
        type: type
    }, null));
    chartK.draw()
}

//K线图表绘制
function drawKChart(type) {
    
    var klt = '101'
    if (type == 'DK') {
        klt = '101'
    } else if (type == 'WK') {
        klt = '102'
    } else if (type == 'MK') {
        klt = '103'
    } else if (type == 'M5K') {
        klt = '5'
    } else if (type == 'M15K') {
        klt = '15'
    } else if (type == 'M30K') {
        klt = '30'
    } else if (type == 'M60K') {
        klt = '60'
    }

    var kConfig = {
        id: '#chart2',
        code: window.market + "." + window.code,
        ut: 'f057cbcbce2a86e2866ab8877db1d059',
        //width: 375,            
        //height: 400,            
        beg: '',
        end: '20500000',
        lmt: '66',
        klt: klt,
        fqt: '1',
        cursor: true,
        simplemode: true,
        simpletype: 'kline',
        cursorCallback: function (data, index, state,config) {
            // data 是数据 ，index是当前数据的位置，state 是滑动状态   
            showKChartData(data, index, state,klt,config.lmt)    
        }
    }
    var kline = new mobilequotechart(kConfig)
    kline.init()
}

function isSearch() {
    let ref = window.document.referrer == "" ? "no referrer" : window.document.referrer;
    //let arr = ['bing.com', 'baidu.com', 'so.com', 'google.com', 'yahoo.com', 'sohu.com', 'sogou.com'];
    let arr = ['.so.','.360.','.chinaso.','.shatangju.','.haosou.','.210v.','.bing.','.soso.','.yicha.','.baidu.','.sm-tc.','.sm.','.yangsou.','.sogo.','.sogou.','.youdao.','.1422.','.baiducontent.','.stock1.','.google.','.iwencai.','.yahoo.'] //扩充搜索引擎，参考大数据
    return (arr.some((v) => {
      return ref.indexOf(v) >= 0
    }))
  }

function goAppAuto(){
    try {
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        if((MK == 0 || MK == 1 || MK == GG_CODE)&&!isWx&&!bIsAndroid){
            if(isSearch()){
                // 如果是来自搜索引擎，则尝试跳转APP
                let usercollect = window.btoa(`wap.ssyq.${window.emtj_pageId}.${getCookie("st_pvi")}`)
                let options = {
                    linkType : 818,
                    parm:`market=${MK}&stockCode=${CODE}`,
                    keepSecond:3,
                    sharetype:`app.start.${usercollect}`,
                    failHandle:'0',// IOS无法唤醒APP则回到原页面。0：5秒返回原页面，1：跳转appstore
                    callback:function(){
                        console.log('未安装APP')
                    }
                }
                emawake.openApp.open(options)
            }
        }
    } catch (error) {
        
    }
}

function goAppClick(type){
    try {
        if(!isWx){
            // let options = {
            //     linkType : 818,
            //     parm:`market=${MK}&stockCode=${CODE}`,
            //     keepSecond:3,
            //     sharetype:'',
            //     failHandle:'1',// IOS无法唤醒APP则打开APP市场。0：5秒返回原页面，1：跳转appstore
            //     callback:function(schem){
            //         //未安装APP
            //         if(type == 'zx'){
            //             window.location.href = 'https://acttg.eastmoney.com/pub/xxlout_dfcfappdfcfWAP_random_0005084a'
            //         }else if(type == 'page'){
            //             window.open('https://acttg.eastmoney.com/pub/xxlout_dfcfappdfcfWAP_random_0005084a')
            //             window.location.href = 'https://acttg.eastmoney.com/pub/xxlout_dfcfappdfcfWAP_random_0005086a'
            //         }
            //         if(type == 'zx'){
            //             window.location.href = "https://emwap.eastmoney.com/h52n?type=stock&code="+code +"&market=" + market + "&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0005084a"
            //         }else if(type == 'page'){
            //             window.location.href = "https://emwap.eastmoney.com/h52n?type=stock&code="+code +"&market=" + market + "&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0005086a"
            //         }
            //     }
            // }
            // emawake.openApp.open(options)
            if(type == 'zx'){
                window.location.href = "https://emstatic.eastmoney.com/awaken/app/share.html?linktype=818&stockCode="+code +"&market=" + market + "&channel=https%3A%2F%2Facttg.eastmoney.com%2Fpub%2Fxxlout_dfcfappdfcfWAP_random_0005084a"
            }else if(type == 'page'){
                let shareId = ""
                if(isIOS()){
                    shareId = encodeURIComponent(`eastmoney://page/stockpage?code=${code}&market=${market}`)
                }else{
                    shareId =  encodeURIComponent(`dfcft://stock?market=${market}&code=${code}`)
                }
                let mdtype = ""
                if(location.search.indexOf("appfenxiang=1") > -1){
                    mdtype = "gghq"
                    window.location.href = "https://mlink.eastmoney.com/h52n/nlink.html"+`?type=localurl&id=${shareId}&mdtype=${mdtype}`
                }else{
                    window.location.href = "https://mlink.eastmoney.com/h52n/nlink.html"+`?type=localurl&id=${shareId}&curl=xxlout_dfcfappdfcfWAP_random_0005086a`
                }
            }
        }
    } catch (error) {
        
    }
}

function isIOS(){
    var UA = navigator.userAgent
    var Agents = ["iPhone", "iPad", "iPod"];
    for (var i = 0; i < Agents.length; i++) {
        if (UA.indexOf(Agents[i]) > 0) {
            return true;
        }
    }
    return false;
  }
window.isIOS = isIOS

function showKChartData(data,index,state,type,lmt) { 
    var json = JSON.parse(sessionStorage.getItem("data"))
    var bond = isBond(json.data.f107,json.data.f111,json.data.f182)
    var ktotal = Number(lmt) - 20
    var trends = data.trends.slice(-ktotal)
    if (state == 'start' || state == 'move') {
        //var _color = formartColorNew(trends[index].price,trends[index].zs)
        var _color = Number(trends[index].zdf) > 0 ? 'red' : ((Number(trends[index].zdf) < 0) ? 'green' : 'gray')
        $('#stock_uk_top').hide()
        $('#stock_bond_top').hide()
        var top_tlp,bottom_tlp,ph_tlp
        if(isqh()){
            top_tlp = `
            <div class="top-p">
                <div id="inum">
                    <p class="stock-value ${_color}" style="font-size: 2rem;">
                        ${trends[index].price}
                    </p>
                    <p>
                    <span class="${_color}">${toFix(trends[index].zdf,2)}%</span><span class="${_color}">${trends[index].zde}</span>
                    </p>
                </div>
                <div>
                    <div class="row">
                        <p>
                            <span>今开</span><span class="${formartColorNew(trends[index].openprice,trends[index].zs)}">${trends[index].openprice}</span>
                        </p>
                        <p>
                            <span>最高</span><span class="${formartColorNew(trends[index].maxprice,trends[index].zs)}">${trends[index].maxprice}</span>
                        </p>
                        <p>
                            <span>最低</span><span class="${formartColorNew(trends[index].minprice,trends[index].zs)}">${trends[index].minprice}</span>
                        </p>
                    </div>
                    <div class="row">
                        <p>
                            <span>总手</span><span>${conversion(trends[index].volume,'calc',2)}</span>
                        </p>
                        <p>
                            <span>持仓</span><span>${conversion(json.data.f133,'calc',2)}</span>
                        </p>
                        <p>
                            <span>日增</span><span class="${formartColorNew(json.data.f133-json.data.f132,0)}">${formateToSub(json.data.f133,json.data.f132)}</span>
                        </p>
                    </div>
                </div>
            </div>`
        }else if(isqq()){
            top_tlp = `
            <div class="top-p">
                <div id="inum">
                    <p class="stock-value ${_color}" style="font-size: 2rem;">
                        ${trends[index].price}
                    </p>
                    <p>
                        <span class="${_color}">${toFix(trends[index].zdf,2)}%</span><span class="${_color}">${trends[index].zde}</span>
                    </p>
                </div>
                <div>
                    <div class="row">
                        <p>
                            <span>今开</span><span class="${formartColorNew(trends[index].openprice,trends[index].zs)}">${trends[index].openprice}</span>
                        </p>
                        <p>
                            <span>最高</span><span class="${formartColorNew(trends[index].maxprice,trends[index].zs)}">${trends[index].maxprice}</span>
                        </p>
                        <p>
                            <span>最低</span><span class="${formartColorNew(trends[index].minprice,trends[index].zs)}">${trends[index].minprice}</span>
                        </p>
                    </div>
                    <div class="row">
                        <p>
                            <span>总手</span><span>${conversion(trends[index].volume,'calc',2)}</span>
                        </p>
                        <p>
                            <span>金额</span><span>${conversion(trends[index].amount,'calc',2)}</span>
                        </p>
                        <p>
                            <span>量比</span><span>${formartDataNew(json.data.f50,json.data.f152,json.data.f152)}</span>
                        </p>
                    </div>
                </div>
            </div>`
        }else if(MK == MG_CODE_NS || MK == MG_CODE_NJ || MK == MG_CODE_MJ || MK == FD_CODE){
            top_tlp = `
            <div class="top-p">
                <div id="inum">
                    <p class="stock-value ${_color}" style="font-size: 2rem;">
                        ${trends[index].price}
                    </p>
                    <p>
                        <span class="${_color}">${toFix(trends[index].zdf,2)}%</span><span class="${_color}">${trends[index].zde}</span>
                    </p>
                </div>
                <div>
                    <div class="row">
                        <p>
                            <span>今开</span><span class="${formartColorNew(trends[index].openprice,trends[index].zs)}">${trends[index].openprice}</span>
                        </p>
                        <p>
                            <span>最高</span><span class="${formartColorNew(trends[index].maxprice,trends[index].zs)}">${trends[index].maxprice}</span>
                        </p>
                        <p>
                            <span>最低</span><span class="${formartColorNew(trends[index].minprice,trends[index].zs)}">${trends[index].minprice}</span>
                        </p>
                    </div>

                    <div class="row">
                        <p>
                            <span>换手</span><span>${trends[index].hs}%</span>
                        </p>
                        <p>
                            <span>总手</span><span>${conversion(trends[index].volume,'calc',2)}</span>
                        </p>
                        <p>
                            <span>总值</span><span>${conversion(json.data.f116,'calc',2)}</span>
                        </p>
                    </div>
                </div>
            </div>
        `
        }else if((bond && json.data.f182 != 11) || json.data.f182 == 98){
            top_tlp = ``
        }else{
            top_tlp = `
            <div class="top-p">
                <div id="inum">
                    <p class="stock-value ${_color}" style="font-size: 2rem;">
                        ${trends[index].price}
                    </p>
                    <p>
                        <span class="${_color}">${toFix(trends[index].zdf,2)}%</span><span class="${_color}">${trends[index].zde}</span>
                    </p>
                </div>
                <div>
                    <div class="row">
                        <p>
                            <span>今开</span><span class="${formartColorNew(trends[index].openprice,trends[index].zs)}">${trends[index].openprice}</span>
                        </p>
                        <p>
                            <span>最高</span><span class="${formartColorNew(trends[index].maxprice,trends[index].zs)}">${trends[index].maxprice}</span>
                        </p>
                        <p>
                            <span>最低</span><span class="${formartColorNew(trends[index].minprice,trends[index].zs)}">${trends[index].minprice}</span>
                        </p>
                    </div>

                    <div class="row">
                        <p>
                            <span>换手</span><span>${trends[index].hs}%</span>
                        </p>
                        <p>
                            <span>总手</span><span>${conversion(trends[index].volume,'calc',2)}</span>
                        </p>
                        <p>
                            <span>金额</span><span>${conversion(trends[index].amount,'calc',2)}</span>
                        </p>
                    </div>
                </div>
            </div>
        `
        }
        if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS||iswh()||isyy()||ishj()){
            if(bond == 1 && json.data.f182 != 11){
                bottom_tlp = `
                <div id="bondul" class="bond-container">
                <div class="bond-container-left">
                    <div>
                        <p class="${_color}">${trends[index].price}</p>
                        <p class="bond-precent">
                            <span class="${_color}">${toFix(trends[index].zdf,2)}%</span>
                            <span class="${_color}">${trends[index].zde}</span>
                        </p>
                    </div>
                </div>
                <div class="bond-container-right">
                    <ul>
                        <li>
                            <p>总成交量</p>
                            <p>${conversion(json.data.f47,'calc',2)}</p>
                        </li>
                        <li>
                            <p>最新YTM</p>
                            <p>${json.data.f703 == "-"?"--":formartDataNew(json.data.f703,json.data.f154,json.data.f152)+"%"}</p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p>总成交额</p>
                            <p>${conversion(json.data.f48,'calc',2)}</p>
                        </li>
                        <li>
                            <p>最近成交方式</p>
                            <p>${returnTransactionMode(json.data.f706)}</p>
                        </li>
                    </ul>
                </div>
                <div class="bond-more">
                    <i class="bond-more-button"></i>
                </div>
            </div>`
            }else if(bond == 3 && json.data.f182 != 11){
                bottom_tlp = `
                <div id="bondul" class="bond-container">
                    <div class="bond-container-left">
                        <div>
                            <p class="${_color}">${trends[index].price}</p>
                            <p class="bond-precent">
                                <span class="${_color}">${toFix(trends[index].zdf,2)}%</span>
                                <span class="${_color}">${trends[index].zde}</span>
                            </p>
                        </div>
                    </div>
                    <div class="bond-container-right">
                        <ul>
                            <li>
                                <p>成交量</p>
                                <p>${conversion(json.data.f47,'calc',2)}</p>
                            </li>
                            <li>
                                <p>最新YTM</p>
                                <p>${json.data.f703=="-"?"--":formartDataNew(json.data.f703,json.data.f154,json.data.f152)+"%"}</p>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <p>成交额</p>
                                <p>${conversion(json.data.f48,'calc',2)}</p>
                            </li>
                            <li>
                                <p>涨跌BP</p>
                                <p>${json.data.f704=="-"?"--":formartDataNew(json.data.f704/100,json.data.f152,json.data.f152)}</p>
                            </li>
                        </ul>
                    </div>
                    <div class="bond-more">
                        <i class="bond-more-button"></i>
                    </div>
                </div>`
            }else if((bond == 2 || bond == 4) && json.data.f182 != 11){
                bottom_tlp = `
                <div id="bondul" class="bond-container">
                <div class="bond-container-left">
                    <div>
                        <p class="${_color}">${data.trends[index].price}</p>
                        <p class="bond-precent">
                            <p class="${_color}" style="text-align: center;">${formartDataNew((data.trends[index].price - data.trends[index].zs)*100,0,2) + 'BP'}</p>
                        </p>
                    </div>
                </div>
                <div class="bond-container-right">
                    <ul>
                        <li>
                            <p>加权平均</p>
                            <p>${formartDataNew(json.data.f71,json.data.f59,json.data.f59)}</p>
                        </li>
                        <li>
                            <p>加权涨跌</p>
                            <p>${json.data.f705 == '-' ? '-' : formartDataNew(json.data.f705,json.data.f152,json.data.f152) +' BP'}</p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p>成交量</p>
                            <p>${conversion(json.data.f47,'calc',2)}</p>
                        </li>
                        <li>
                            <p>昨加权</p>
                            <p>${formartDataNew(json.data.f721,json.data.f59,json.data.f59)}</p>
                        </li>
                    </ul>
                </div>
                <div class="bond-more">
                    <i class="bond-more-button"></i>
                </div>
            </div>
                `
            }else if(bond && json.data.f182 == 11){
                // 可转债
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span>昨收</span><span>${formartDataNew(json.data.f60,json.data.f59,json.data.f59)}</span></p>
                    <p>
                        <span class="stock-span">转股价值</span><span>${formartDataNew(json.data.f427,json.data.f154,json.data.f152)}</span>
                    </p>
                    <p>
                        <span class="stock-span">转股溢价</span><span class="${formartColorNew(json.data.f428,0)}">${json.data.f428 == "-"?"--":formartDataNew(json.data.f428,json.data.f152,json.data.f152)+"%"}</span>
                    </p>
                    <p>
                        <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore('zq')">更多</a>
                    </p>
                </div>
                <div class="bottom-extra" onclick="loadmorezg('${json.data.f262}')">
                    <p>
                        <span>正股报价:</span>
                        &nbsp;&nbsp;&nbsp;
                        <span>${json.data.f264}</span>
                        &nbsp;&nbsp;&nbsp;
                        <span class="${formartColorNew(json.data.f267,json.data.f266)}">${json.data.f267=="-"?"--":formartDataNew(json.data.f267,json.data.f265,json.data.f265)}</span>
                        &nbsp;&nbsp;&nbsp;
                        <span class="${formartColorNew(json.data.f267,json.data.f266)}">${json.data.f268=="-"?"--":formatAffix(formartDataNew(json.data.f268,json.data.f265,json.data.f265),"+","%")}</span>
                    </p>
                    <p style="margin-right: 10px;">
                        <span>&nbsp;</span><a>
                            <i class="arrow-right-new"></i>
                        </a>
                    </p>
                </div>
                `
            }else{
                if(json.data.f182 == 98){
                    bottom_tlp = `
                            <div id="bondul" class="bond-container">
                            <div class="bond-container-left">
                                <div>
                                    <p class="${_color}">${trends[index].price}</p>
                                    <p class="bond-precent">
                                        <span class="${_color}">${toFix(trends[index].zdf,2)}%</span>
                                        <span class="${_color}">${trends[index].zde}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="bond-container-right">
                                <ul>
                                    <li>
                                        <p>成交量</p>
                                        <p>${conversion(json.data.f47,'calc',2)}</p>
                                    </li>
                                    <li>
                                        <p>成交额</p>
                                        <p>${conversion(json.data.f48,'calc',2)}</p>
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <p>成交笔数</p>
                                        <p>${conversion(json.data.f296,'calc',2)}</p>
                                    </li>
                                    <li>
                                        <p>昨收</p>
                                        <p>${formartDataNew(json.data.f60,json.data.f59,json.data.f59)}</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="bond-more">
                                <i class="bond-more-button"></i>
                            </div>
                        </div>
                    `
                }else{
                    if((json.data.f107 == 0 && json.data.f111 == 80) || (json.data.f107 == 1 && json.data.f111 == 23)){
                        // 创业板 或者 科创板显示盘后数据
                        if(Number(type) > 100){
                            if(Number(type) == 101){
                                bottom_tlp = `
                                    <div class="bottom-p">
                                        <p><span style="color:black;text-align:left;line-height:2.5rem">${trends[index].time}</span></p>
                                        <p>
                                        <span>盘后量</span><span>${trends[index].phvolume == '0' ? '-' : trends[index].phvolume}</span>
                                        </p>
                                        <p>
                                            <span>盘后额</span><span>${trends[index].phamount == '0' ? '-' : conversion(trends[index].phamount,'calc',2)}</span>
                                        </p>
                                        <p>
                                            <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                                        </p>
                                    </div>
                                `
                            }else{
                                bottom_tlp = `
                                    <div class="bottom-p">
                                        <p><span>总值</span><span>${conversion(json.data.f116,'calc',2)}</span></p>
                                        <p>
                                        <span>盘后量</span><span>${trends[index].phvolume == '0' ? '-' : trends[index].phvolume}</span>
                                        </p>
                                        <p>
                                            <span>盘后额</span><span>${trends[index].phamount == '0' ? '-' : conversion(trends[index].phamount,'calc',2)}</span>
                                        </p>
                                        <p>
                                            <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                                        </p>
                                    </div>
                                `
                            }
                        }else{
                            bottom_tlp = `
                            <div class="bottom-p">
                                <p><span>总值</span><span>${conversion(json.data.f116,'calc',2)}</span></p>
                                <p>
                                    <span>流值</span><span>${conversion(json.data.f117,'calc',2)}</span>
                                </p>
                                <p>
                                    <span>市盈<sup>TTM</sup></span><span>${formartDataNew(json.data.f164,json.data.f152,2)}</span>
                                </p>
                                <p>
                                    <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                                </p>
                            </div>
                            `
                        }
                    }else{
                        bottom_tlp = `
                        <div class="bottom-p">
                            <p><span>总值</span><span>${conversion(json.data.f116,'calc',2)}</span></p>
                            <p>
                                <span>流值</span><span>${conversion(json.data.f117,'calc',2)}</span>
                            </p>
                            <p>
                                <span>市盈<sup>TTM</sup></span><span>${formartDataNew(json.data.f164,json.data.f152,2)}</span>
                            </p>
                            <p>
                                <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                            </p>
                        </div>
                        `
                    }
                }
            }
        }else if(MK == GG_CODE||MK == YG_CODE_LD || MK == YG_CODE_LDGJ){
            if(Number(type) == 101){
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span style="color:black;text-align:left;line-height:2.5rem">${trends[index].time}</span></p>
                    <p>
                        
                    </p>
                    <p>
                        
                    </p>
                    <p>
                        <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                    </p>
                </div>
                `
            }else{
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span>总值</span><span>${conversion(json.data.f116,'calc',2)}</span></p>
                    <p>
                        <span>市盈</span><sup>TTM</sup><span>${formartDataNew(json.data.f164,json.data.f152,3)}</span>
                    </p>
                    <p>
                        <span>市净率</span><span>${formartDataNew(json.data.f167,json.data.f152,2)}</span>
                    </p>
                    <p>
                        <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore()">更多</a>
                    </p>
                </div>
                `
            }
            
        }else if(MK == MG_CODE_NS || MK == MG_CODE_NJ || MK == MG_CODE_MJ || MK == FD_CODE){
            if(Number(type) == 101){
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span style="color:black;text-align:left;line-height:2.5rem">${trends[index].time}</span></p>
                    <p>
                        
                    </p>
                    <p>
                        
                    </p>
                    <p>
                        <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                    </p>
                </div>
                `
            }else{
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span>52周高</span><span>${formartDataNew(json.data.f174,json.data.f152,2)}</span></p>
                    <p>
                        <span>52周低</span><span>${formartDataNew(json.data.f175,json.data.f152,2)}</span>
                    </p>
                    <p>
                        <span>市盈</span><span>${formartDataNew(json.data.f164,json.data.f152,3)}</span>
                    </p>
                    <p>
                        <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                    </p>
                 </div>
                `
            }
        }else if(MK == ZS_CODE_YB || MK == QIHUO_ZS || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1){
            if(Number(type) == 101){
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span style="color:black;text-align:left;line-height:2.5rem">${trends[index].time}</span></p>
                    <p>
                        
                    </p>
                    <p>
                        
                    </p>
                    <p>
                        <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                    </p>
                </div>
                `
            }else{
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span>昨收</span><span>${formartDataNew(json.data.f60,json.data.f59,2)}</span></p>
                    <p></p><p></p><p></p>
                </div>
                `
            }
            
        }else if(MK == BK_CODE_NO){
            if(Number(type) == 101){
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span style="color:black;text-align:left;line-height:2.5rem">${trends[index].time}</span></p>
                    <p>
                        
                    </p>
                    <p>
                        
                    </p>
                    <p>
                        <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                    </p>
                </div>
                `
            }else{
               bottom_tlp = `
                <div class="bottom-p">
                    <p><span>涨家数</span><span style="color:red">${json.data.f113}</span></p>
                    <p><span>平家数</span><span>${json.data.f115}</span></p>
                    <p><span>跌家数</span><span style="color:green">${json.data.f114}</span></p>
                    <p>
                        <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                    </p>
                </div>
                ` 
            }
            
        }else if(isqh()){
            bottom_tlp = `
            <div class="bottom-p">
                <p><span>结算</span><span>${formartDataNew(json.data.f131,json.data.f59,json.data.f59)}</span></p>
                <p><span>昨结</span><span>${formartDataNew(json.data.f130,json.data.f59,json.data.f59)}</span></p>
                <p><span></span><span></span></p>
                <p>
                    <span>&nbsp;</span><a href="javascript:void(0);" class="btn-more" onclick="loadmore();">更多</a>
                </p>
            </div>
            `  
        }else if(isqq()){
            if(Number(type) == 101){
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span style="color:black;text-align:left;line-height:2.5rem">${trends[index].time}</span></p>
                    <p>
                        
                    </p>
                    <p>
                        
                    </p>
                    <p>
                        
                    </p>
                </div>
                `
            }else{
                bottom_tlp = `
                <div class="bottom-p">
                    <p><span>昨收</span><span>${formartDataNew(json.data.f60,json.data.f59,json.data.f59)}</span></p>
                    <p>
                        <span>外盘</span><span class="red">${formartDataNew(json.data.f49,'calc',2)}</span>
                    </p>
                    <p>
                        <span>内盘</span><span class="green">${formartDataNew(json.data.f161,'calc',2)}</span>
                    </p>
                    <p>
                        
                    </p>
                </div>
                `
            }
        }
        if((bond && json.data.f182 != 11) || json.data.f182 == 98){
            var _html = `${top_tlp}${bottom_tlp}`
            $('#stock_bond_top').hide()
            $('#stock_bond_chart').html(_html)
            $('#stock_bond_chart').show()
        }else{
            $('#stock_chart_top').html(`<div id="snapul">${top_tlp}${bottom_tlp}</div>`)
            $('#stock_chart_top').show()
        }
    }
    if (state == 'end') {
        $('#stock_chart_top').hide()
        $('#stock_bond_chart').hide()
        if((bond && json.data.f182 != 11) || json.data.f182 == 98){
            $('#stock_bond_top').show()
        }else{
            $('#stock_uk_top').show()
        }
    }
 }

//行情接口jsonp调用
function pandoraCall(data) {

}

var isfirst = true;
//按需执行下面的跨域请求
function hqCall(json) {
    var self = this
    if (!json || !json.data)
    return;
    sessionStorage.setItem("data",JSON.stringify(json))
    json.data.f58 = json.data.f58.substring(0,12)
    if (isfirst) {
        //修改页面标题
        //document.title = json.data.f58 + "(" + json.data.f57 + ") " + document.title;
        //替换交易url
        if (document.getElementById("lijiaoyi")) {
            document.getElementById("lijiaoyi").onclick = function () {
                window.location.href = document.getElementById("lijiaoyi").attributes["data-url"].nodeValue.replace("{name}", json.data.f58);
            }
        }
        if(json.data.f292 == '1'){
            // 盘前
            sessionStorage.setItem("fsstatus",1)
        }else if(json.data.f292 == '17' || json.data.f292 == '18' ||json.data.f292 == '19'){
            sessionStorage.setItem("fsstatus",2)
        }else{
            sessionStorage.setItem("fsstatus",0)
        }

        initialmenu();
        initChart();
        isfirst = false;
    }
    $("#mmp-list").hide();
    EM.Template.config("escape", false);
    $("#js_stockname").val(json.data.f58);
    $("#js_bkhy").val(json.data.f127 + '|' + json.data.f198);
    $("#js_f60").val(json.data.f60);
    $("#js_f59").val(json.data.f59);
    var logoArr = calclogo(json.data.f177);
    if(json.data.f256 != '-'){
        // 说明存在AH比价相关
        loadAHData(json.data);
    }
    if (MK == GG_CODE) {
        // 如果属于港股情况下，显示买卖盘菜单元素标签，并赋值。
        $("#mmp-list").show();
        var logostr = '';
        if (logoArr != null && logoArr.length > 0) {
            logoArr = logoArr.slice(0,3) // 2021.08.09 龚晓雨
            for (var i = 0; i < logoArr.length; i++) {
                logostr += '<span class="stock-lbl" style="">' + logoArr[i] + '</span>';
            }
        }
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + logostr + "</div>";
        $(".comm-nav .tit").html(title);
        var html = EM.Template('stock_hk_top_tlp', json);
        var _url = "https://mpassport.eastmoney.com/login?backurl=" + encodeURIComponent(location.href)
        document.getElementById('stock_uk_top').innerHTML = html;
        if (isCN) {
            // 判断是否登录
            if (getCookie("uidal") != null && getCookie("uidal") != undefined && getCookie("uidal") != "") {
                // 加载右侧行情，十档行情
                var html = EM.Template('stock_hk_top_hq', json);
                document.getElementById('content_hq').innerHTML = html;
                // 加载底部买卖盘数据
                isRefresh = true
                loadJjData();
            } else {
                if (parseInt(json.data.f177) & (128 | 256 | 512 | 1024)) {
                    // 加载右侧行情，一档行情
                    var html = EM.Template('stock_hk_top_hq1', json); // stock_hk_top_hq1 为1当行情
                    document.getElementById('content_hq').innerHTML = html;
                    isRefresh = true
                } else {
                    var html = EM.Template('stock_hk_top_hq2', json); // stock_hk_top_hq2 为0当行情
                    document.getElementById('content_hq').innerHTML = html;
                    isRefresh = false
                }
            }
        } else {
            var html = EM.Template('stock_hk_top_hq2', json); // stock_hk_top_hq2 为0当行情
            document.getElementById('content_hq').innerHTML = html;
            isRefresh = false
        }

    } else if (MK == MG_CODE_NS || MK == MG_CODE_NJ || MK == MG_CODE_MJ || MK == FD_CODE) {
        // 美股
        var logostr = '';
        if(MK == FD_CODE){
            logoArr.push('粉')
        }
        if (logoArr != null && logoArr.length > 0) {
            logoArr = logoArr.slice(0,3) // 2021.08.09 龚晓雨
            for (var i = 0; i < logoArr.length; i++) {
                logostr += '<span class="stock-lbl" style="">' + logoArr[i] + '</span>';
            }
        }
        //var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>" + logostr;
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + logostr + "</div>";
        $(".comm-nav .tit").html(title);

        var html = EM.Template('stock_us_top_tlp', json);
        document.getElementById('stock_uk_top').innerHTML = html;
    } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS || MK == QIHUO_ZS || MK == ZSS_ZS) {
        var logostr = '';
        if (json.data.f107 == 1 && json.data.f111 == 23) {
            if (json.data.f107 == 1 && json.data.f182 == 33) {
                //科创板CDR
                logoArr.unshift('科创板CDR')
            }else{
                logoArr.unshift('科创板')
            }
        }
        if ((json.data.f107 == 0) && (json.data.f181 & 2048)){
            logoArr.unshift('北交所')
        }
        if ((json.data.f107 == 155 || json.data.f107 == 156) && json.data.f181 & 1) {
            //沪伦通GDR
            logoArr.push('沪伦通GDR')
        }
        if (json.data.f107 == 1 && json.data.f182 == 31) {
            //沪伦通CDR
            logoArr.push('沪伦通CDR')
        }
        if (json.data.f294 == 1) {
            // 注册
            logoArr.push('注')
        }
        if (json.data.f107 == 0 && json.data.f182 == 86) {
            //创业板CDR
            logoArr.push('创业板CDR')
        }
        if (json.data.f288 == 1) {
            // 未盈利
            logoArr.push('未盈利')
        }
        if (json.data.f293 == 1) {
            // 表决权
            logoArr.push('表决权')
        }
        if (json.data.f295 == 1) {
            // 协议控制
            logoArr.push('协议控制')
        }
        // 创业板新增广告
        if(json.data.f107 == 0 &&json.data.f111 == 80){
            if(json.data.f292 == 5 || json.data.f292 == 19){
                var _c = json.data.f43-json.data.f60 > 0 ? 'red' : (json.data.f43-json.data.f60 < 0 ? 'green' : '')
                var cyhtml = "<p style='line-height:2.2rem;padding:0 0.8rem;font-size:1.4rem'>盘后固定价格:&nbsp;&nbsp;<span class=" + _c + ">" + formartDataNew(json.data.f43,json.data.f59,json.data.f59) + "</span>&nbsp;&nbsp;量:&nbsp;&nbsp;" + json.data.f260 + "&nbsp;&nbsp;额:&nbsp;&nbsp;" + ConvertToNum(json.data.f261) +"</p>"
                $('.cy-notice').html(cyhtml)
                $('.cy-notice').css('display','block')
            }
        }
        // 科创板
        if(json.data.f107 == 1 && json.data.f111 == 23){
            if(json.data.f292 == 5 || json.data.f292 == 19){
                var _c = json.data.f43-json.data.f60 > 0 ? 'red' : (json.data.f43-json.data.f60 < 0 ? 'green' : '')
                var cyhtml = "<p style='line-height:2.2rem;padding:0 0.8rem;font-size:1.4rem'>盘后固定价格:&nbsp;&nbsp;<span class=" + _c + ">" + formartDataNew(json.data.f43,json.data.f59,json.data.f59) + "</span>&nbsp;&nbsp;量:&nbsp;&nbsp;" + json.data.f260 + "&nbsp;&nbsp;额:&nbsp;&nbsp;" + ConvertToNum(json.data.f261) +"</p>"
                $('.cy-notice').html(cyhtml)
                $('.cy-notice').css('display','block')
            }
        }
        if (logoArr != null && logoArr.length > 0) {
            logoArr = logoArr.slice(0,3) // 2021.08.09 龚晓雨
            for (var i = 0; i < logoArr.length; i++) {
                logostr += '<span class="stock-lbl" style="">' + logoArr[i] + '</span>';
            }
        }
        // var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>" + logostr;
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + logostr + "</div>";
        $(".comm-nav .tit").html(title);
        if (!iszs()) {
            //if (iszq()) {
            let bond = isBond(json.data.f107,json.data.f111,json.data.f182)
            if (bond) {
                if(bond == 1 && json.data.f182 != 11){
                    $('#stock_uk_top').hide();
                    $('#stock_bond_top').show();
                    var html = EM.Template('stock_bond_top_tlp_sz', json);
                    document.getElementById('stock_bond_top').innerHTML = html;
                }else if(bond == 3 && json.data.f182 != 11){
                    $('#stock_uk_top').hide();
                    $('#stock_bond_top').show();
                    var html = EM.Template('stock_bond_top_tlp_sh', json);
                    document.getElementById('stock_bond_top').innerHTML = html;
                }else if((bond == 2 || bond == 4) && json.data.f182 != 11){
                    $('#stock_uk_top').hide();
                    $('#stock_bond_top').show();
                    var html = EM.Template('stock_bond_top_tlp_nhg', json);
                    document.getElementById('stock_bond_top').innerHTML = html;
                }else if((json.data.f107 == 0 || json.data.f107 == 1) && json.data.f182 == 11){
                    // 可转债顶部数据
                    var html = EM.Template('stock_zq_top_tlp', json);
                    document.getElementById('stock_uk_top').innerHTML = html;
                }else{
                    var html = EM.Template('stock_hs_top_tlp', json);
                    document.getElementById('stock_uk_top').innerHTML = html;
                }
                if(bond == 1 && json.data.f182 != 11){
                    var zqnotice = `<ul>
                        <li>
                            <span>匹配成交价</span><span class='${formartColorNew(json.data.f700,json.data.f60)}'>${formartDataNew(json.data.f700,json.data.f59,json.data.f59)}</span>
                        </li>
                        <li>
                            <span>匹配成交涨幅</span>
                            <span class='${formartColor1(json.data.f731)}'>${json.data.f731 == '-'?'-':formartDataNew(json.data.f731,json.data.f152,json.data.f152)+"%"}</span>
                        </li>
                        <li>
                            <span>匹配成交量</span><span>${conversion(json.data.f701,'calc',2)}</span>
                        </li>
                        <li>
                            <span>匹配成交额</span><span>${conversion(json.data.f702,'calc',2)}</span>
                        </li>
                    </ul>`
                    $('.zq-notice').html(zqnotice);
                    $('.zq-notice').show();
                }
                //右侧行情
                if(!(MK == MG_CODE_NS || MK == MG_CODE_NJ || MK == MG_CODE_MJ || MK == ZS_CODE_YB || MK == QIHUO_ZS || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1 || iszs() || MK == BK_CODE_NO || isqh() || iswh() || ishj() || isyy() || isqq() || iszq() || MK == FD_CODE)){
                    html = EM.Template('stock_hs_top_hq', json);
                    document.getElementById('content_hq').innerHTML = html;
                    loadRightHq();
                }
            } else {
                //顶部信息
                var html = EM.Template('stock_hs_top_tlp', json);
                document.getElementById('stock_uk_top').innerHTML = html;

                //右侧行情
                html = EM.Template('stock_hs_top_hq', json);
                document.getElementById('content_hq').innerHTML = html;

                json.data.AmtNetMax = Math.max(Math.abs(json.data.f140), Math.abs(json.data.f143), Math.abs(json.data.f146), Math.abs(json.data.f149));
                html = EM.Template('stock_hs_zjlx', json);
                document.getElementById('js_zjlx').innerHTML = html;

                
                if (json.data.f178 != null && json.data.f178 != '' && json.data.f178 != '-') {
                    var zjwrzj = eval(json.data.f178);
                    // if (zjwrzj.length >= 5) {
                    //     json.data.AmtNetMaxNew = Math.max(Math.abs(zjwrzj[0].mainNetAmt), Math.abs(zjwrzj[1].mainNetAmt), Math.abs(zjwrzj[2].mainNetAmt), Math.abs(zjwrzj[3].mainNetAmt), Math.abs(zjwrzj[4].mainNetAmt));
                    //     json.data.fiveDaysDate1 = zjwrzj[4].date.substr(5, 5);
                    //     json.data.fiveDaysData1 = zjwrzj[4].mainNetAmt;
                    //     json.data.fiveDaysDate2 = zjwrzj[3].date.substr(5, 5);
                    //     json.data.fiveDaysData2 = zjwrzj[3].mainNetAmt;
                    //     json.data.fiveDaysDate3 = zjwrzj[2].date.substr(5, 5);
                    //     json.data.fiveDaysData3 = zjwrzj[2].mainNetAmt;
                    //     json.data.fiveDaysDate4 = zjwrzj[1].date.substr(5, 5);
                    //     json.data.fiveDaysData4 = zjwrzj[1].mainNetAmt;
                    //     json.data.fiveDaysDate5 = zjwrzj[0].date.substr(5, 5);
                    //     json.data.fiveDaysData5 = zjwrzj[0].mainNetAmt;
                    //     html = EM.Template('stock_hs_zjl', json);
                    //     document.getElementById('five_zjl').innerHTML = html;
                    // }
                    if (zjwrzj.length >= 1) {
                        //json.data.AmtNetMaxNew = Math.max(Math.abs(zjwrzj[0].mainNetAmt), Math.abs(zjwrzj[1].mainNetAmt), Math.abs(zjwrzj[2].mainNetAmt), Math.abs(zjwrzj[3].mainNetAmt), Math.abs(zjwrzj[4].mainNetAmt));
                        var arr = []
                        for(var i = 0 ; i < zjwrzj.length ; i++){
                            arr.push(Math.abs(zjwrzj[i].mainNetAmt))
                        }
                        mpSort(arr)
                        json.data.AmtNetMaxNew = arr[arr.length-1]
                        zjwrzj.reverse()
                        for(var i = 0 ; i < zjwrzj.length ; i++){
                            zjwrzj[i].date = zjwrzj[i].date.substr(5, 5);
                        }
                        json.data.zjwrzj = zjwrzj
                        html = EM.Template('stock_hs_zjl_new', json);
                        document.getElementById('five_zjl').innerHTML = html;
                    }
                }
                loadRightHq();
            }
        } else {
            //指数
            if(json.data.f182 == 98){
                //债券指数
                $('#stock_uk_top').hide();
                $('#stock_bond_top').show();
                var html = EM.Template('stock_bond_top_tlp_zs', json);
                document.getElementById('stock_bond_top').innerHTML = html;
            }else{
                var html = EM.Template('stock_zssz_top_tlp', json);
                document.getElementById('stock_uk_top').innerHTML = html;
            }
            

            if (MK == CHOICE_ZS) {
                $('#zpd_div').hide()
            }

            json.data.AmtNetMax = Math.max(Math.abs(json.data.f140), Math.abs(json.data.f143), Math.abs(json.data.f146), Math.abs(json.data.f149));
            html = EM.Template('stock_zs_zjlx', json);
            document.getElementById('js_zjlx').innerHTML = html;

            if (json.data.f178 != null && json.data.f178 != '' && json.data.f178 != '-') {
                var zjwrzj = eval(json.data.f178);
                if (zjwrzj.length >= 1) {
                    // json.data.AmtNetMaxNew = Math.max(Math.abs(zjwrzj[0].mainNetAmt), Math.abs(zjwrzj[1].mainNetAmt), Math.abs(zjwrzj[2].mainNetAmt), Math.abs(zjwrzj[3].mainNetAmt), Math.abs(zjwrzj[4].mainNetAmt));
                    // json.data.fiveDaysDate1 = zjwrzj[4].date.substr(5, 5);
                    // json.data.fiveDaysData1 = zjwrzj[4].mainNetAmt;
                    // json.data.fiveDaysDate2 = zjwrzj[3].date.substr(5, 5);
                    // json.data.fiveDaysData2 = zjwrzj[3].mainNetAmt;
                    // json.data.fiveDaysDate3 = zjwrzj[2].date.substr(5, 5);
                    // json.data.fiveDaysData3 = zjwrzj[2].mainNetAmt;
                    // json.data.fiveDaysDate4 = zjwrzj[1].date.substr(5, 5);
                    // json.data.fiveDaysData4 = zjwrzj[1].mainNetAmt;
                    // json.data.fiveDaysDate5 = zjwrzj[0].date.substr(5, 5);
                    // json.data.fiveDaysData5 = zjwrzj[0].mainNetAmt;
                    var arr = []
                    for(var i = 0 ; i < zjwrzj.length ; i++){
                        arr.push(Math.abs(zjwrzj[i].mainNetAmt))
                    }
                    mpSort(arr)
                    json.data.AmtNetMaxNew = arr[arr.length-1]
                    zjwrzj.reverse()
                    for(var i = 0 ; i < zjwrzj.length ; i++){
                        zjwrzj[i].date = zjwrzj[i].date.substr(5, 5);
                    }
                    json.data.zjwrzj = zjwrzj
                    html = EM.Template('stock_zs_zjl_new', json);
                    document.getElementById('five_zjl').innerHTML = html;
                }
            }
            loadRightHq();
        }
        if (MK == 159 || MK == 223) {
            $('#go-pc').hide()
        }
    } else if (MK == YG_CODE_LD || MK == YG_CODE_LDGJ) {
        var logostr = '';
        if (logoArr != null && logoArr.length > 0) {
            logoArr = logoArr.slice(0,3) // 2021.08.09 龚晓雨
            for (var i = 0; i < logoArr.length; i++) {
                logostr += '<span class="stock-lbl" style="">' + logoArr[i] + '</span>';
            }
        }
        var tt = json.data.f58;
        if (tt != null && tt.length > 20) {
            tt = json.data.f58.substr(0, 20) + "...";
        }
        //var title = "<span style='font-size:16px'>" + tt + "</span>" + "<br/><span style='font-size:14px'>" + json.data.f57 + "</span>" + logostr;
        var title = "<div style='font-size:18px' id='stock-tit'>" + tt + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:14px'>" + json.data.f57 + "</span>" + logostr + "</div>";
        $(".comm-nav .tit").html(title);
        $(".comm-nav .tit").attr("title", json.data.f58);
        var html = EM.Template('stock_uk_top_tlp', json);
        document.getElementById('stock_uk_top').innerHTML = html;
        html = EM.Template('stock_uk_top_hq', json);
        document.getElementById('content_hq').innerHTML = html;

        //json.data.AmtNetMax = Math.max(Math.abs(json.data.f140), Math.abs(json.data.f143), Math.abs(json.data.f146), Math.abs(json.data.f149));
        //html = EM.Template('stock_uk_zjlx', json);
        //document.getElementById('js_zjlx').innerHTML = html;

        loadRightHq();
    } else if (MK == ZS_CODE_YB || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1 || MK == QIHUO_ZS) {
        //var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>"
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + "</div>";
        $(".comm-nav .tit").html(title);

        var html = EM.Template('stock_zs_top_tlp', json);
        document.getElementById('stock_uk_top').innerHTML = html;
    } else if (MK == BK_CODE_NO) {
        //var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>"
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + "</div>";
        $(".comm-nav .tit").html(title);

        var html = EM.Template('stock_bk_top_tlp', json);
        document.getElementById('stock_uk_top').innerHTML = html;
    } else if (isqh()) {
        //var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>"
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + "</div>";
        $(".comm-nav .tit").html(title);

        var html = EM.Template('stock_qh_top_tlp', json);
        document.getElementById('stock_uk_top').innerHTML = html;
    } else if (iswh()) {
        //var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>"
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + "</div>";
        $(".comm-nav .tit").html(title);

        var html = EM.Template('stock_wh_top_tlp', json);
        document.getElementById('stock_uk_top').innerHTML = html;
    } else if (ishj()) {
        //var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>"
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + "</div>";
        $(".comm-nav .tit").html(title);

        var html = EM.Template('stock_hj_top_tlp', json);
        document.getElementById('stock_uk_top').innerHTML = html;
    } else if (isyy()) {
        //var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>"
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + "</div>";
        $(".comm-nav .tit").html(title);

        if (MK == "113") {
            var html = EM.Template('stock_yy_top_tlp', json);
            document.getElementById('stock_uk_top').innerHTML = html;
        } else {
            var html = EM.Template('stock_yyo_top_tlp', json);
            document.getElementById('stock_uk_top').innerHTML = html;
        }
    } else if (isqq()) {
        //var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>"
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + "</div>";
        $(".comm-nav .tit").html(title);

        var html = EM.Template('stock_qq_top_tlp', json);
        document.getElementById('stock_uk_top').innerHTML = html;
        if(MK == "11" || MK == "221"){
            $('.btn-more').hide()
        }
    }
    else{ //其他行情支持的品种
        //var title = "<span style='font-size:18px'>" + json.data.f58 + "</span>" + "<br/><span style='font-size:16px'>" + json.data.f57 + "</span>"
        var title = "<div style='font-size:18px' id='stock-tit'>" + json.data.f58 + "<span id='expand-fullName' style='display:none;'><i class='expand-full-title'></i></span></div>" + "<div><span style='font-size:16px'>" + json.data.f57 + "</span>" + "</div>";
        $(".comm-nav .tit").html(title);

        var html = EM.Template('stock_qq_top_tlp', json);
        document.getElementById('stock_uk_top').innerHTML = html;        
        $('.btn-more').hide()
    }

    if(json.data.f58){
        if(json.data.f58.length > 10 && json.data.f58.length <16){
            $('.comm-nav .tit').css('transform', 'scale(0.85)')
        }else if(json.data.f58.length >= 16 && json.data.f58.length < 25){
            $('.comm-nav .tit').css('transform', 'scale(0.8)')
        }else if(json.data.f58.length >= 25){
            $('.comm-nav .tit').css('transform', 'scale(0.7)')
        }
    }
    // 扩位展示
    if(json.data.f734 && json.data.f734 != '-'){
        $("#expand-fullName").css('display','inline-block')
        $("#expand-fullName").on('click',function(){
            $("#pop-mask").show();
            $(".expand-pop").show()
            $("#expandFullName").html(json.data.f734)
        })

        $("#expand-confirm").on('click',function(){
            $("#pop-mask").hide();
            $(".expand-pop").hide()
        })
         
        $("#pop-mask").on('click',function(){
            $("#pop-mask").hide();
            $(".expand-pop").hide()
        })
    }
    refresh();
}

function hqCallRight(json) {
    EM.Template.config("escape", false);

    json.data.f60 = $("#js_f60").val();
    json.data.f59 = $("#js_f59").val();

    var dataArr = [];
    if (json != null && json.data != null && json.data.details != null && json.data.details.length > 0) {
        for (var item = json.data.details.length - 1; item >= 0; item--) {
            dataArr.push(json.data.details[item]);
        }
        json.data.details = dataArr;
    }

    if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
        if (iszs()) {
            html = EM.Template('stock_hs_cjmx', json);
            document.getElementById('bottomPankouContainer').innerHTML = html;
        } else {
            var hqjson = JSON.parse(sessionStorage.getItem("data"))
            var bond = isBond(hqjson.data.f107,hqjson.data.f111,hqjson.data.f182);
            if(bond == 1 && hqjson.data.f182 != 11){
                var html = EM.Template('stock_zq_right_tlp', json);
                document.getElementById('stock_uk_right').innerHTML = html;
            }else{
                var html = EM.Template('stock_hs_right_tlp', json);
                document.getElementById('stock_uk_right').innerHTML = html;
            }

            html = EM.Template('stock_hs_cjmx', json);
            document.getElementById('bottomPankouContainer').innerHTML = html;
        }
    } else if (MK == YG_CODE_LD || MK == YG_CODE_LDGJ) {
        var html = EM.Template('stock_uk_right_tlp', json);
        document.getElementById('stock_uk_right').innerHTML = html;

        html = EM.Template('stock_uk_cjmx', json);
        document.getElementById('bottomPankouContainer').innerHTML = html;

        //处理英股右侧分时交易默认展开
        $("#stock_uk_right").removeClass('tb-fenshi');
    }
}

function hqJjCall(json) {
    var sellArr = [];
    var buyArr = [];
    if (json != null && json != '') {
        if (json.data != '' || json.data.brkq != '') {
            $.each(json.data.brkq, function (i) {
                if (json.data.brkq[i] != '') {
                    if (json.data.brkq[i].substr(0, 1) == 'S') {
                        json.data.brkq[i] = json.data.brkq[i].split(':')[1];
                        $.each(json.data.brkq[i].split(','), function (j) {
                            sellArr.push(json.data.brkq[i].split(',')[j]);
                        })
                    } else if (json.data.brkq[i].substr(0, 1) == 'B') {
                        json.data.brkq[i] = json.data.brkq[i].split(':')[1];
                        $.each(json.data.brkq[i].split(','), function (j) {
                            buyArr.push(json.data.brkq[i].split(',')[j]);
                        })
                    }
                }
            })
        }
    }
    var data = [];
    data.SellArr = sellArr;
    data.BuyArr = buyArr;
    var html = EM.Template('tlp_stock_hk_xw', data);
    //给买卖盘 DIV 填充数据
    document.getElementById('mmp-list').innerHTML = html;
}

function eoxdiv() {
    var rclass = $("#rightbox").attr("class");
    if (rclass == "right-p") {
        $("#rightbox").removeClass("right-p");
        $("#rightbox").addClass("right-p expand-fenshi");

        $("#btn-fenshi").find('i').eq(0).addClass('icon-trangle rotate');
    } else {
        $("#rightbox").removeClass("right-p expand-fenshi");
        $("#rightbox").addClass("right-p");

        $("#btn-fenshi").find('i').eq(0).removeClass('icon-trangle rotate');
        $("#btn-fenshi").find('i').eq(0).addClass('icon-trangle');
    }
}
window.eoxdiv = eoxdiv

function loadmore(tab) {
    let env = window.location.search
    if(env.indexOf("?env=test") > -1){
        location.href = "/quote/stockmore.html?id=" + CODE + "&mk=" + MK + "&tab=" + tab + '&env=test';
    }else{
        location.href = "/quote/stockmore.html?id=" + CODE + "&mk=" + MK + "&tab=" + tab;
    }
}

window.loadmore = loadmore

function loadmorehk() {
    location.href = "/quote/stockmore.html?id=" + CODE + "&mk=" + MK;
}
window.loadmorehk = loadmorehk

function loadmorezg(code) {
    location.href = `/quote/stock/${MK}.${code}.html`
}
window.loadmorezg = loadmorezg

function ConvertToNum(value) {
    if (value == "" || value == "-") {
        return value;
    }
    if (parseInt(value) < 10000) {
        return value;
    } else if (parseInt(value) > 999999999999) {
        return (parseFloat(value) * 1.0 / 1000000000000).toFixed(2) + "万亿";
    } else if (parseInt(value) > 99999999) {
        return (parseFloat(value) * 1.0 / 100000000).toFixed(2) + "亿";
    } else {
        return (parseFloat(value) * 1.0 / 10000).toFixed(2) + "万";
    }
}

function formateToSub(value1, value2) {
    if (isNaN(Number(value1)) || isNaN(Number(value2))) {
        return 0;
    } else {
        return value1 - value2;
    }
}

// 单位转换
function conversion (value, unit, point, singlenp) { //singlenp:1个位数时不需要保留小数位
    if (value == null || value == "-" || value == "0") {
        if (value != null && value != '-' && unit != 'calc') {
            return value + unit;
        } else {
            return value;
        }
    }
    if (point == '' || point == null || point == undefined || point == 'undefined') {
        point == 2;
    }
    if (unit == "calc") {
        var temp = Number(value);
        if (parseInt(temp) < 10000) {
            if (temp.toFixed(2) == 0.00) {
                return 0;
            } else {
                if (singlenp == 1) {
                    return temp
                } else {
                    return temp.toFixed(point);
                }
            }
        } else if (parseInt(temp) > 999999999999) {
            return (parseFloat(temp) * 1.0 / 1000000000000).toFixed(point) + "万亿";
        } else if (parseInt(temp) > 99999999) {
            return (parseFloat(temp) * 1.0 / 100000000).toFixed(point) + "亿";
        } else {
            return (parseFloat(temp) * 1.0 / 10000).toFixed(point) + "万";
        }
    } else {
        return value + unit;
    }
}

function formartColor1(value){
    if (value == null || value == "-") {
        return "";
    }
    return (value > 0 ? 'red' : (value < 0 ? 'green' : ''))
}

//股吧加载更多数据
function loadmorgubadata() {
    $("#js_gb_final").hide();
    $("#js_loadmore11").hide();
    $("#js_loadmore21").hide();
    $("#js_gb_nodata").hide();
    $("#onLoadingUI_gb").show();

    page++;
    loadguba(page, 0);
}

window.loadmorgubadata = loadmorgubadata

//股吧热点加载更多数据
function loadmorehotgubadata() {
    $("#js_gb_final").hide();
    $("#js_loadmore11").hide();
    $("#js_loadmore21").hide();
    $("#js_gb_nodata").hide();
    $("#onLoadingUI_gb").show();

    page1++;
    loadhotguba(page1, 0);
}

window.loadmorehotgubadata = loadmorehotgubadata

//新闻加载更多数据
function loadmorenews() {
    pagenews++;
    _loadnews(pagenews, 0);
}

window.loadmorenews = loadmorenews

//公告加载更多数据
function loadmorenotice() {
    pagenotice++;
    //loadnews(pagenotice, 2);
    _loadnews(pagenotice, 2);
}

window.loadmorenotice = loadmorenotice

//研报加载更多数据
function loadmoreyb() {
    pageyb++;
    //loadnews(pageyb, 3);
    _loadnews(pageyb,1)
}

window.loadmoreyb = loadmoreyb

function getstockkind(type, single) {
    if (single == "1") {
        switch (type) {
            case "0":
                return "2";
            case "1":
                return "1";
            default:
                return "";
        }
    } else {
        switch (type) {
            case "0":
                return "02";
            case "1":
                return "01";
            default:
                return "";
        }
    }
}
//模板方法注册
function tempRegister() {

    EM.Template.helper.escape = false;

    EM.Template.helper("formartData", function (value, rate, digit) {
        if(value == null){
            return "--"
        }
        var num = Number(value);
        var r = Number(rate);
        var temp = 1;
        if (r && r > 0) {
            for (var a = 0; a < r; a++) {
                temp = temp * 10;
            }
        }
        else {
            for (var a = 0; a < r; a++) {
                temp = temp / 10;
            }
        }
        if (num) {
            return (num / temp).toFixed(digit)
        }
        return value;
    });

    EM.Template.helper("formartFontSize", function (value, num) {
        if (value != null && value != undefined) {
            if (value.toString().length > num) {
                return true;
            }
            return false;
        } else {
            return false;
        }
    });
    // 添加前后缀
    EM.Template.helper("formatAffix", function (value, prefix,postfix) {
        if (value != null && value != undefined) {
            if(value > 0){
                return prefix + value + postfix
            }else if(value == 0){
                return "0.00" + postfix
            }else{
                return value + postfix
            }
        }
    });

    EM.Template.helper("formartUnit", function (value, unit, point, singlenp) {//singlenp:1个位数时不需要保留小数位
        if (value == null || value == "-" || value == "0") {
            if (value != null && value != '-' && unit != 'calc') {
                return value + unit;
            } else {
                return value;
            }
        }
        if (point == '' || point == null || point == undefined || point == 'undefined') {
            point == 2;
        }
        if (unit == "calc") {
            var temp = Number(value);
            if (parseInt(temp) < 10000) {
                if (temp.toFixed(2) == 0.00) {
                    return 0;
                } else {
                    if (singlenp == 1) {
                        return temp
                    } else {
                        return temp.toFixed(point);
                    }
                }
            } else if (parseInt(temp) > 999999999999) {
                return (parseFloat(temp) * 1.0 / 1000000000000).toFixed(point) + "万亿";
            } else if (parseInt(temp) > 99999999) {
                return (parseFloat(temp) * 1.0 / 100000000).toFixed(point) + "亿";
            } else {
                return (parseFloat(temp) * 1.0 / 10000).toFixed(point) + "万";
            }
        } else {
            return value + unit;
        }
    });

    EM.Template.helper("formartUnitNeiWaiPan", function (value, unit, point, colornumber) {//singlenp:1个位数时不需要保留小数位
        let returnstr;
        if (value == null || value == "-" || value == "0") {
            if (value != null && value != '-' && unit != 'calc') {
                returnstr = value + unit;
            } else {
                returnstr = value;
            }
        }
        else{
            if (point == '' || point == null || point == undefined || point == 'undefined') {
                point == 2;
            }
            if (unit == "calc") {
                var temp = Number(value);
                if (parseInt(temp) < 10000) {
                    if (temp.toFixed(2) == 0.00) {
                        returnstr = 0;
                    } else {
                        // if (singlenp == 1) {
                        //     returnstr = temp
                        // } else {
                            returnstr = temp.toFixed(point);
                        // }
                    }
                } else if (parseInt(temp) > 999999999999) {
                    returnstr = (parseFloat(temp) * 1.0 / 1000000000000).toFixed(point) + "万亿";
                } else if (parseInt(temp) > 99999999) {
                    returnstr = (parseFloat(temp) * 1.0 / 100000000).toFixed(point) + "亿";
                } else {
                    returnstr = (parseFloat(temp) * 1.0 / 10000).toFixed(point) + "万";
                }
            } else {
                returnstr = value + unit;
            }            
        }

        if(isNaN(colornumber / 1)  || isNaN(returnstr / 1)) return '<span>' + returnstr + '</span>'

        if((colornumber / 1) > 0){
            return '<span class="red">' + returnstr + '</span>'
        }
        if((colornumber / 1) < 0){
            return '<span class="green">' + returnstr + '</span>'
        }

    });    

    EM.Template.helper("formartUnitPk", function (value) {
        if (value == null || value == "-") {
            return "";
        }
        return Math.round(Number(value)/10000)
    });

    EM.Template.helper("formartDirection", function (value, value1) {
        if (value == null || value == "-" || value1 == null || value1 == "-") {
            return "";
        }

        if (parseFloat(value) > parseFloat(value1)) {
            return "icons-stock-up";
        } else if (parseFloat(value) < parseFloat(value1)) {
            return "icons-stock-down";
        } else {
            return "";
        }
    });

    EM.Template.helper("formartDirectionSpace", function (value, value1) {
        if (value == null || value == "-" || value1 == null || value1 == "-") {
            return "&nbsp;&nbsp;";
        }

        if (parseFloat(value) > parseFloat(value1)) {
            return "";
        } else if (parseFloat(value) < parseFloat(value1)) {
            return "";
        } else {
            return "&nbsp;&nbsp;";
        }
    });

    EM.Template.helper("formartZero", function (value) {
        if (value == 0) {
            return value;
        } else {
            return value;
        }
    });

    //十万
    EM.Template.helper("formartSW", function (value) {
        if (value == null || value == "-") {
            return value;
        }
        var temp = Number(value);
        if (parseInt(temp) >= 100000) {
            return parseInt(parseFloat(temp) / 10000).toFixed(0) + "万";
        } else {
            return value;
        }
    });

    EM.Template.helper("formartUnitSpe", function (value, point, unit, isquzheng) {
        if (value == null || value == "-") {
            return value + unit;
        }
        if (isquzheng) {
            return Math.round(parseFloat(value) * 1.0 / point) + unit;
        } else {
            return (parseFloat(value) * 1.0 / point) + unit;
        }
    });

    EM.Template.helper("formartColor", function (value, value1) {
        if (value == null || value == "-" || value1 == null || value1 == "-") {
            return "";
        }

        if (value.toString() == "0" || value.toString() == "0.0" || value.toString() == "0.00" || value.toString() == "0.000" || value.toString() == "0.0000") {
            return "gray";
        }

        if (parseFloat(value) > parseFloat(value1)) {
            return "red";
        } else if (parseFloat(value) < parseFloat(value1)) {
            return "green";
        } else if(parseFloat(value) == parseFloat(value1)){
            return "black"
        }else{
            return ""
        }
    });

    EM.Template.helper("formartColor1", function (value) {
        if (value == null || value == "-") {
            return "";
        }
        return (value > 0 ? 'red' : (value < 0 ? 'green' : ''))
    });

    EM.Template.helper("FormateArr", function (value, position) {
        if (value == null || value == "-") {
            return value;
        }

        if (position == 0) {
            return value.split(',')[position].substr(0, 5);
        } else {
            return value.split(',')[position];
        }
    });

    //EM.Template.helper("FormateArrAddSpace", function (value, position) {
    //    if (value == null || value == "-") {
    //        return value;
    //    }
    //    var _str = "";
    //    for (var i = 0; i < 8 - value.toString().length; i++) {
    //        _str += "&ensp;";
    //    }
    //    return _str + value;
    //});

    EM.Template.helper("FormateArrTY", function (value, position, sp) {
        if (value == null || value == "-") {
            return value;
        }

        return value.split(sp)[position];
    });

    EM.Template.helper("FormateGubaDate", function (value) {
        if (value == null || value == "-") {
            return value;
        }

        var date = new Date(),
            year = date.getFullYear(),
            month = date.getMonth() + 1,
            day = date.getDate();

        month = (month.toString().length < 2 ? "0" + month.toString() : month.toString());
        day = (day.toString().length < 2 ? "0" + day.toString() : day.toString());
        if ((year + "-" + month + "-" + day) == value.substr(0, 10)) {
            return "今天 " + value.substr(11, 5);
        } else {
            return value.substr(5, 11);
        }
    });

    EM.Template.helper("FormateGubaShowFace", function (a) {
        var b, c;
        a = a.replace(/href= target='_blank'/gi, 'href="javascript:;"');
        b = ["微笑", "大笑", "鼓掌", "不说了", "为什么", "哭", "不屑", "怒", "滴汗", "拜神", "胜利", "亏大了", "赚大了", "牛", "俏皮", "傲", "好困惑", "兴奋", "赞", "不赞", "摊手", "好逊", "失望", "加油", "困顿", "想一下", "围观", "献花", "大便", "爱心", "心碎", "毛估估", "成交", "财力", "护城河", "复盘", "买入", "卖出", "满仓", "空仓", "抄底", "看多", "看空", "加仓", "减仓"];
        c = new RegExp("\\[.+?\\]", "ig");
        a = a.replace(c, function (a) {
            for (var c = 0; c < b.length; c++) {
                if ("[" + b[c] + "]" == a) {
                    if (9 > c) {
                        return '<img title="' + b[c] + '" src="https://gbres.eastmoney.com/face/emot/emot0' + (c + 1) + '.png" alt="' + a + '">'
                    }
                    else {
                        return '<img title="' + b[c] + '" src="https://gbres.eastmoney.com/face/emot/emot' + (c + 1) + '.png" alt="' + a + '">';
                    }
                }
            }
            return a;
        });
        return a;
    });

    EM.Template.helper("FormateDateLongToStr", function (value) {
        if (value == null || value == "-") {
            return value;
        }

        var date = new Date(value);
        var month = date.getMonth() + 1;
        var day = date.getDate();

        month = month.toString().length < 2 ? "0" + month.toString() : month.toString();
        day = day.toString().length < 2 ? "0" + day.toString() : day.toString();
        return date.getFullYear() + "-" + month + "-" + day;
    });

    EM.Template.helper("FormateSub", function (value1, value2) {
        if (isNaN(Number(value1)) || isNaN(Number(value2))) {
            return 0;
        } else {
            return value1 - value2;
        }
    })
    EM.Template.helper("FormateSubZJ", function (value1, value2) {
        if (isNaN(Number(value1))) {
            return '-';
        }
        else if (!isNaN(Number(value1)) && isNaN(Number(value2))) {
            return value1;
        }
        else {
            return value1 - value2;
        }
    })
    
    EM.Template.helper("returnTransactionMode", function (val) {
        var res = ''
        if(val == 1){
            res = '匹配成交'
        }else if(val == 2){
            res = '协商成交'
        }else if(val == 4){
            res = '点击成交'
        }else if(val == 8){
            res = '意向申报'
        }else if(val == 16){
            res = '询价成交'
        }else if(val == 32){
            res = '竞买成交'
        }else if(val == 64){
            res = '匹配成交大额'
        }else{
            res = '-'
        }
        return res
    })
    // 上证债券数据处理，value - 交易状态，data - 数据源
    EM.Template.helper("returnTradeStatus", function (value,data) {
        var state = ['','开盘竞价','交易中','盘中休市','收盘竞价','已收盘','停牌','退市','暂停上市','未上市','未开盘','盘前','盘后','休市','盘中停牌','非交易代码','波动性中断','盘后交易启动','盘后集中撮合交易','盘后固定价格交易']
        if(value !== null && value !== undefined){
            if(value == 6){
                return state[value]
            }else{
                return `<span class="${formartColorNew(data.f43,data.f60)}">${formartUnit(formartData(data.f170,data.f152,data.f152),'%')}</span>
                <span class="${formartColorNew(data.f43,data.f60)}">${formartData(data.f169,data.f59,data.f59)}</span>`
            }
        }
    })
}

//加载顶部行情
function loadTopHq() {
    var url = quotaConfig.host + quotaConfig.tPath + "?secid=" + MK + "." + CODE + "&ut=" + quotaConfig.token + "&forcect=1" + "&fields=f13,f19,f20,f23,f24,f25,f26,f27,f28,f29,f30,f43,f44,f45,f46,f47,f48,f49,f50,f57,f58,f59,f60,f71,f85,f107,f111,f113,f114,f115,f116,f117,f127,f130,f131,f132,f133,f135,f136,f137,f138,f139,f140,f141,f142,f143,f144,f145,f146,f147,f148,f149,f152,f154,f161,f162,f164,f165,f167,f168,f169,f170,f171,f174,f175,f177,f178,f181,f182,f198,f199,f251,f252,f253,f254,f255,f256,f257,f260,f261,f262,f263,f264,f265,f266,f267,f268,f288,f292,f293,f294,f295,f296,f427,f428,f530,f531,f700,f701,f702,f703,f704,f705,f706,f721,f731,f734&invt=2&cb=?"+delayparams;
    $.ajax({
        type: "get",
        url: url,
        dataType: "jsonp",
        success: function (data, status, xhr) {
            hqCall(data)
        },
        error: function (e) {
            // console.log(e);
        }
    });
}

//加载右侧分时成交数据行情
function loadRightHq() {
    var url = quotaConfig.host + quotaConfig.rPath + "?secid=" + MK + "." + CODE + "&ut=" + quotaConfig.token + "&forcect=1" + "&fields1=f1,f2,f3,f4,f5&fields2=f51,f52,f53,f54,f55&pos=-14&iscca=1&invt=2&cb=?"+delayparams;
    $.ajax({
        type: "get",
        url: url,
        dataType: "jsonp",
        success: function (data, status, xhr) {
            hqCallRight(data)
            //这里的success方法是不会执行的，会调用上传pandoraCall方法，该方法名和服务器回传内容的方法名一致
            //console.log(data);
            //console.log(status);
            //console.log(xhr);
        },
        error: function (e) {
            //console.log(e);
        }
    });
}

//加载港股席位行情数据
function loadJjData() {
    var url = quotaConfig.host + quotaConfig.hPath + "?secid=" + MK + "." + CODE + "&ut=" + quotaConfig.token + "&forcect=1" + "&invt=2&fields=f1,f2,f3,f4,f5&cb=?";
    $.ajax({
        type: "get",
        url: url,
        dataType: "jsonp",
        success: function (data, status, xhr) {
            hqJjCall(data)
            //这里的success方法是不会执行的，会调用上传pandoraCall方法，该方法名和服务器回传内容的方法名一致
            //console.log(data);
            //console.log(status);
            //console.log(xhr);
        },
        error: function (e) {
            //console.log(e);
        }
    });
}

//加载所属成份股行情数据（板块）
function loadCfgHq() {
    var url = quotaConfig.host + quotaConfig.bcPath + "?ut=" + quotaConfig.token + "&forcect=1" + "&fs=b:" + CODE + "&pn=" + pagecfg + "&pz=10&po=" + cfgsortdir + "&fid=" + cfgsortseg + "&invt=2&cb=?";
    $.ajax({
        type: "get",
        url: url,
        dataType: "jsonp",
        success: function (data, status, xhr) {
            hqBk(data)
            //这里的success方法是不会执行的，会调用上传pandoraCall方法，该方法名和服务器回传内容的方法名一致
        checkIP    //console.log(data);
            //console.log(status);
            //console.log(xhr);
        },
        error: function (e) {
            console.log(e);
        }
    });
}

// // 判断用户是否登录
// function isLogin(){

// }

//判断用户是否为内地IP
function checkIP() {
    //港股行情需要判断是否为内地IP 该接口访问的lt可以区分
    //0是无法判断归属地，1是中国大陆，2是非中国大陆地区
    var self = this
    var url = `https://push2.eastmoney.com/api/qt/stock/get?${delayparams.substring(1)}`
    var xhr = $.ajax({
        url: url,
        async: false
    });
    var data = JSON.parse(xhr.responseText)
    isCN = data?.lt == 1 ? true : false
}

function loadcfgmore() {
    pagecfg++;
    loadCfgHq();
}

window.loadcfgmore = loadcfgmore

//成份股排序处理
$("#cfgzx_sort").click(function () {
    $("#cfgzd_sort").find('i').removeClass();
    $("#ulcfgContainer").html('');
    var iobj = $(this).find('i');
    if ($(this).data('dir') == "down") {
        iobj.removeClass();
        iobj.addClass("sprite-ico icons-index-down up");

        pagecfg = 1;
        cfgsortdir = 0;
        cfgsortseg = 'f2';
        $(this).data('dir', 'up');
    } else {
        iobj.removeClass();
        iobj.addClass("sprite-ico icons-index-down");
        pagecfg = 1;
        cfgsortdir = 1;
        cfgsortseg = 'f2';
        $(this).data('dir', 'down');
    }
    loadCfgHq();
})

$("#cfgzd_sort").click(function () {
    $("#cfgzx_sort").find('i').removeClass();
    $("#ulcfgContainer").html('');
    var iobj = $(this).find('i');
    if ($(this).data('dir') == "down") {
        iobj.removeClass();
        iobj.addClass("sprite-ico icons-index-down up");

        pagecfg = 1;
        cfgsortdir = 0;
        cfgsortseg = 'f3';
        $(this).data('dir', 'up');
    } else {
        iobj.removeClass();
        iobj.addClass("sprite-ico icons-index-down");
        pagecfg = 1;
        cfgsortdir = 1;
        cfgsortseg = 'f3';
        $(this).data('dir', 'down');
    }
    loadCfgHq();
});

function hqBk(json) {
    if (json != null && json != '') {
        var totalpage = 0;
        if (json.data.total % 10 == 0) {
            totalpage = parseInt(json.data.total / 10);
        } else {
            totalpage = parseInt(json.data.total / 10) + 1;
        }

        if (pagecfg < totalpage) {
            $("#cfgmore").show();
            $("#cfgnomore").hide();
        } else if (pagecfg == totalpage) {
            $("#cfgmore").hide();
            $("#cfgnomore").show();
        } else {
            $("#cfgnomore").show();
            return false;
        }

        if (pagecfg == 1) {
            var html = EM.Template('stock_bk_cfg', json);
            document.getElementById('ulcfgContainer').innerHTML = html;
        } else {
            var html = EM.Template('stock_bk_cfg', json);
            $("#ulcfgContainer").find("dd").last().after(html);
        }
    }
}

function gubaCodeChange(code) {
    switch (MK) {
        case YG_CODE_LD:
            return "lse" + code;
        case YG_CODE_LDGJ:
            return "lseiob" + code;
        case HS_CODE_SS:
            return "sz" + code;
        case HS_CODE_HS:
            return "sh" + code;
        case CHOICE_ZS:
            return "sh" + code;
        case GG_CODE:
            return "hk" + code;
        case BK_CODE_NO:
            return code.toLowerCase()
        case MG_CODE_MJ: //107
        case MG_CODE_NJ: //106
        case MG_CODE_NS: //105
            return "us" + code;
        case "100":
            return "qqzs|" + code;
        case "113":
            return "shfe" + code;
        case "114":
            return "dce" + code;
        case "115":
            return "czce" + code;
        case "225":
            return "gfex" + code;            
        case "8":
            return "gzqh" + code;
        case "108":
            return "nybot" + code;
        case "119":
            return "forex" + code;
        case "120":
            return "cnyrate" + code;
        case "121":
            return "cnyforex" + code;
        case "133":
            return "cnyoffs" + code;
        case "122":
            return "forpm" + code;
        case "118":
            return "sge" + code
        case "10":
            return "" + code;
        case "111":
            return "tocom" + code;
        case "112":
            return "ipe" + code;
        case "102":
            return "nymex" + code;
        case "142":
            return "ine" + code;
    }
}

function isPC() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) ){
      return true
    }return false
}

function gubadata(data) {
    var dataa = [];
    // dataa.data = JSON.parse(data.Result);
    dataa.data = data
    $("#spanTotalArticleCount").text(ConvertToNum(dataa.data.count));
    if (dataa.data.re.length == 0) {
        $("#ulgbContainer").hide();
        $("#js_gb_nodata").show();
        $("#onLoadingUI_gb").hide();
        return false;
    } else if (dataa.data.re.length < 20) {
        $("#js_loadmore11").hide();
        $("#onLoadingUI_gb").hide();
        $("#js_gb_final").show();
        $("#ulgbContainer").show();
    } else {
        $("#js_loadmore11").show();
        $("#onLoadingUI_gb").hide();
        $("#ulgbContainer").show();
    }

    EM.Template.config("escape", false);
    if (page == 1) {
        if (MK == GG_CODE) {
            var html = EM.Template('stock_hk_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
            var html = EM.Template('stock_us_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
            var html = EM.Template('stock_hs_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == YG_CODE_LD || MK == YG_CODE_LDGJ) {
            var html = EM.Template('stock_uk_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == ZS_CODE_YB || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1) {
            var html = EM.Template('stock_zs_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == BK_CODE_NO) {
            var html = EM.Template('stock_bk_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (isqh() || iswh() || ishj() || isyy()) {
            var html = EM.Template('stock_qh_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (isqq()) {
            var html = EM.Template('stock_qq_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (iszq()) {
            var html = EM.Template('stock_zq_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        }
    } else {
        if (MK == GG_CODE) {
            var html = EM.Template('stock_hk_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
            var html = EM.Template('stock_us_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
            var html = EM.Template('stock_hs_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == YG_CODE_LD || MK == YG_CODE_LDGJ) {
            var html = EM.Template('stock_uk_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == ZS_CODE_YB || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1) {
            var html = EM.Template('stock_zs_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == BK_CODE_NO) {
            var html = EM.Template('stock_bk_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (isqh() || iswh() || ishj() || isyy()) {
            var html = EM.Template('stock_qh_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (isqq()) {
            var html = EM.Template('stock_qq_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (iszq()) {
            var html = EM.Template('stock_zq_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        }
    }
}

function loadguba(page, sorttype) {
    var gubacode = CODE
    if(MK == CHOICE_ZS){
        gubacode = 'sh000001'
    }else if(MK == MG_CODE_NS || MK == MG_CODE_NJ || MK == MG_CODE_MJ || MK == FD_CODE){
        gubacode = 'us' + gubacode
    }else if(MK == GG_CODE){
        gubacode = 'hk' + gubacode
    }

    guba_api.default.getArticleListByCode(gubacode, page, sorttype).then(function (data) {
        gubadata(data)
    })

    // if (MK == CHOICE_ZS) {
    //     guba_api.default.getArticleListByCode('sh000001', page, sorttype).then(function (data) {
    //         gubadata(data)
    //     })
    // }
    // else {
    //     guba_api.default.getArticleListByCode(CODE, page, sorttype).then(function (data) {
    //         gubadata(data)
    //     })
    // }



    // console.info(sorttype)
    // var url = "https://wap.eastmoney.com/info/guba/GetApiResultNewCore?url=webarticlelist%2Fapi%2FArticle%2FArticleListForMobile&query=code%253D" + gubaCodeChange(CODE) + "%2526sorttype%253D" + sorttype + "%2526ps%253D20%2526p%253D" + page + "&type=POST&cb=?";
    // //var url = gubaConfig.host + gubaConfig.uPath + "?code=" + CODE + "&sorttype=" + sorttype + "&ps=20&p=" +page + "&pi=" + getCookie("pi") + "&ctoken=" + getCookie("ct") + "&utoken=" +getCookie("ut") + "&deviceid=0d2798cab1716439a343c9965c20c59d&version=2&product=eastmoney&plat=wap";
    // $.ajax({
    //     type: "get",
    //     url: url,
    //     dataType: "jsonp",
    //     success: function (data, status, xhr) {
    //       gubadata(data)
    //         //这里的success方法是不会执行的，会调用上传pandoraCall方法，该方法名和服务器回传内容的方法名一致

    //     },
    //     error: function (e) {
    //     }
    // });
}

function hotgubadata(data) {
    var dataa = [];
    // dataa.data = JSON.parse(data.Result);
    dataa.data = data.result
    $("#spanTotalArticleCount").text(ConvertToNum(dataa.data.count));
    if (dataa.data.re.length == 0) {
        $("#ulgbContainer").hide();
        $("#js_gb_nodata").show();
        $("#onLoadingUI_gb").hide();
        return false;
    } else if (dataa.data.re.length < 20) {
        $("#js_loadmore21").hide();
        $("#onLoadingUI_gb").hide();
        $("#js_gb_final").show();
        $("#ulgbContainer").show();
    } else {
        $("#js_loadmore21").show();
        $("#onLoadingUI_gb").hide();
        $("#ulgbContainer").show();
    }

    EM.Template.config("escape", false);
    if (page1 == 1) {
        if (MK == GG_CODE) {
            var html = EM.Template('stock_hk_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
            var html = EM.Template('stock_us_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
            var html = EM.Template('stock_hs_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == YG_CODE_LD || MK == YG_CODE_LDGJ) {
            var html = EM.Template('stock_uk_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == ZS_CODE_YB || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1) {
            var html = EM.Template('stock_zs_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (MK == BK_CODE_NO) {
            var html = EM.Template('stock_bk_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (isqh() || iswh() || ishj() || isyy()) {
            var html = EM.Template('stock_qh_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (isqq()) {
            var html = EM.Template('stock_qq_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        } else if (iszq()) {
            var html = EM.Template('stock_zq_guba', dataa);
            document.getElementById('ulgbContainer').innerHTML = html;
        }
    } else {
        if (MK == GG_CODE) {
            var html = EM.Template('stock_hk_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
            var html = EM.Template('stock_us_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
            var html = EM.Template('stock_hs_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == YG_CODE_LD || MK == YG_CODE_LDGJ) {
            var html = EM.Template('stock_uk_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == ZS_CODE_YB || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1) {
            var html = EM.Template('stock_zs_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (MK == BK_CODE_NO) {
            var html = EM.Template('stock_bk_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (isqh() || iswh() || ishj() || isyy()) {
            var html = EM.Template('stock_qh_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (isqq()) {
            var html = EM.Template('stock_qq_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        } else if (iszq()) {
            var html = EM.Template('stock_zq_guba', dataa);
            $("#ulgbContainer").find("li").last().after(html);
        }
    }
}

function loadhotguba(page1, sorttype) {
    var gubacode = CODE
    if(MK == CHOICE_ZS){
        gubacode = 'sh000001'
    }else if(MK == MG_CODE_NS || MK == MG_CODE_NJ || MK == MG_CODE_MJ || MK == FD_CODE){
        gubacode = 'us' + gubacode
    }else if(MK == GG_CODE){
        gubacode = 'hk' + gubacode
    }

    $.ajax({
        url: '/quote/api/guba/hotarticlelist',
        type: 'GET',
        dataType: 'json',
        data: {
            code: gubacode,
            page: page1,
            sort: sorttype
        }
    })
        .then(function (json) {
            if (json.re) {
                hotgubadata(json)
            }

        })
        .catch(function (error) {

        })

    // guba_api.default.getHotArticleListByCode(CODE, page1, sorttype).then(function(data){
    //   hotgubadata(data)
    // })
    // //var url = "http://gubaapi.eastmoney.com/v3/read/Article/Post/HotArticleList.aspx?code=" + CODE + "&sorttype=" + sorttype + "&ps=20&p=" + page1 + "&pi=" + getCookie("pi") + "&ctoken=" + getCookie("ct") + "&utoken=" + getCookie("ut") + "&deviceid=0d2798cab1716439a343c9965c20c59d&version=2&product=eastmoney&plat=wap";
    // var url = "https://wap.eastmoney.com/info/guba/GetApiResultNewCore?url=hotpost%2Fapi%2FHotPost%2FHotArticleList&query=code%253D" + gubaCodeChange(CODE) + "%2526sorttype%253D" + sorttype + "%2526ps%253D20%2526p%253D" + page1 + "&type=POST&cb=?";
    // $.ajax({
    //     type: "get",
    //     url: url,
    //     dataType: "jsonp",
    //     success: function (data, status, xhr) {
    //       hotgubadata(data)
    //         //这里的success方法是不会执行的，会调用上传pandoraCall方法，该方法名和服务器回传内容的方法名一致
    //         //console.log(dataa);
    //         //console.log(status);
    //         //console.log(xhr);
    //     },
    //     error: function (e) {
    //     }
    // });
}

function addzan(id) {

    $.ajax({
        url: '/quote/api/guba/likearticle',
        type: 'POST',
        dataType: 'json',
        data: {
            id: id
        }
    })
        .then(function (json) {
            if (json.re) {
                addzancb(json.result)
            }

        })
        .catch(function (error) {

        })
    // var url = "https://wap.eastmoney.com/info/guba/GetApiResultNewCore?url=likeopt%2Fapi%2FLike%2FLikeArticle&query=id%253D" + id + "%2526type%253D0&type=POST&cb=?";
    // $.ajax({
    //     type: "get",
    //     url: url,
    //     dataType: "jsonp",
    //     success: function (data, status, xhr) {
    //       addzancb(data)
    //         //这里的success方法是不会执行的，会调用上传pandoraCall方法，该方法名和服务器回传内容的方法名一致
    //         //console.log(data);
    //         //console.log(status);
    //         //console.log(xhr);
    //     },
    //     error: function (e) {
    //         console.log(e);
    //     }
    // });
}

function cancelzan(id) {
    $.ajax({
        url: '/quote/api/guba/cancellikearticle',
        type: 'POST',
        dataType: 'json',
        data: {
            id: id
        }
    })
        .then(function (json) {
            if (json.re) {
                cancelzancb(json.result)
            }

        })
        .catch(function (error) {

        })


    // var url = "https://wap.eastmoney.com/info/guba/GetApiResultNewCore?url=likeopt%2Fapi%2FLike%2FCancelLikeArticle&query=id%253D" + id + "%2526type%253D0&type=POST&cb=?";
    // $.ajax({
    //     type: "get",
    //     url: url,
    //     dataType: "jsonp",
    //     success: function (data, status, xhr) {
    //       cancelzancb(data)
    //         //这里的success方法是不会执行的，会调用上传pandoraCall方法，该方法名和服务器回传内容的方法名一致
    //         //console.log(data);
    //         //console.log(status);
    //         //console.log(xhr);
    //     },
    //     error: function (e) {
    //         console.log(e);
    //     }
    // });
}

function addzancb(json) {
}

function cancelzancb(json) {
}

function dianzan(id, obj) {
    var iobj = $(obj).find('i').eq(0),
        spanobj = $(obj).find('span').eq(0);
    if (iobj.hasClass("sprite-ico icons-index-up false icons-index-uped")) {
        //取消赞
        iobj.removeClass("sprite-ico icons-index-up false icons-index-uped");
        iobj.addClass("sprite-ico icons-index-up false");

        var num = spanobj.text();
        if (num == '' || num == '0') {
            return false;
        }

        spanobj.text(parseInt(num) - 1);
        cancelzan(id);
    } else {
        iobj.removeClass("sprite-ico icons-index-up false");
        iobj.addClass("sprite-ico icons-index-up false icons-index-uped");

        var num = spanobj.text();
        if (num == '') {
            num = "0";
        }

        spanobj.text(parseInt(num) + 1);
        addzan(id);
    }
}

window.dianzan = dianzan

function loadGb(market,code){
    // var url = '//quote.eastmoney.com/unify/getinnercode/' + market + '.' + code + '.js'
    // $.ajax({
    //     url: url,
    //     type: 'get',
    //     dataType: 'jsonp',
    //     jsonp:'callback',
    //     jsonpCallback:'innerCodeByUnifyId',
    //     success: function (data){
    //         var list = new PageList({
    //             "stockcode":String(data.InnerCode),
    //             "root":"#gb-new",
    //             "isRelease":true
    //         });
    //         list.enter();
    //     },
    //     error:function(){

    //     }
    // })

    var url = '//quote.eastmoney.com/unify/codecenter/' + market + '.' + code + '.js'
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'jsonp',
        // jsonp:'codecenterget',
        jsonpCallback:'codecenterget',
        success: function (data){
            // console.info(data)
            
            var list = new PageList({
                "stockcode":String(data?.innerCode ? data.innerCode : ''),
                "root":"#gb-new",
                "isRelease":true
            });
            list.enter();
        },
        error:function(){

        }
    })

}

//加载报价签数据
// type1 1:逐笔委托 2:逐笔成交
function loadBJ(market,code,type1,type2){
    var bjurl
    var self = this
    var fieldArr = [
        '&tps=0&fields2=f51,f52,f53,f54,f55', // 全部成交
        '&tps=1&fields2=f51,f52,f53,f54,f56,f57', // 匹配成交 依次是时间,买卖方向,价格,数量,结算方式,结算周期
        '&tps=4&fields2=f51,f52,f53,f54,f56,f57,f58,f59', // 点击成交
        '&tps=8&fields2=f51,f52,f53,f54,f56,f57,f58,f59', //意向申报
        '&tps=32&pod=1&fields2=f52,f53,f54,f58', //竞买成交
    ]
    var fieldArr2 = [
        '&tps=0&fields2=f51,f52,f53,f54', //全部成交
        '&tps=1&fields2=f51,f52,f53,f55,f56', //匹配成交
        '&tps=4&fields2=f51,f52,f53,f55,f56', //点击成交
        '&tps=16&fields2=f51,f52,f53,f55,f56', //询价成交
        '&tps=2&fields2=f51,f52,f53,f55,f56', // 协商成交
        '&tps=32&fields=f51,f52,f53,f55,f56' //竞买成交
    ]
    if(type1 == 1){
        bjurl = quotaConfig.host + quotaConfig.zqwtPath + '?ut=f057cbcbce2a86e2866ab8877db1d059&dpt=wz.bondup&lmt=' + bjlmtArr[0][type2] + fieldArr[type2] +  '&fields1=f1,f2,f3,f4,f5&secid=' + market + '.' + code;
    }else{
        bjurl = quotaConfig.host + quotaConfig.zqcjPath + '?ut=f057cbcbce2a86e2866ab8877db1d059&dpt=wz.bondup&lmt=' + bjlmtArr[1][type2] + fieldArr2[type2] +  '&minvol=0&fields1=f1,f2,f3,f4,f5&pos=-10&secid=' + market + '.' + code;
    }
    
    $.ajax({
        url: bjurl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if(data.rc == 0){
                if(type1 == 1){
                    loadZBSB(data,type2)
                }else if(type1 == 2){
                    loadZBCJ(data,type2)
                }

                if(data.data.trans?.length == 0 || data.data.order?.length == 0){
                    $('.stock-bj-loadmore').hide()
                }else{
                    $('.stock-bj-loadmore').show();
                    if(bjlmtArr[type1-1][type2] == data.data.trans?.length || bjlmtArr[type1-1][type2] == data.data.order?.length){
                        // 请求数据条数和返回数据条数相同，代表数据并未加载到头
                        $('.stock-bj-loadmore').html('查看更多<i class="arrow-down"></i>');
                    }else{
                        $('.stock-bj-loadmore').html('已经到底了');
                    }
                }
            }else{
                // 无数据
                $(`#stock-bj-table`).width((document.documentElement.offsetWidth-20))
                $('#deal-bj-table').html('<div class="bj-nodata">该品种暂无相关内容</div>')
                $('#stock-bj-table').html('<div class="bj-nodata">该品种暂无相关内容</div>')
                $('.stock-bj-loadmore').hide()
            }
        }
    })
}

//type: 0:全部成交 1:匹配成交 2:点击成交 3:意向申报 4:竞买成交
function loadZBSB(data,type){
    if(type == 0){
        //全部成交
        var dataArr = []
        $.each(data.data.order, function (i,v) {
            dataArr.push(v.split(','))
        })
        var data = {
            ele:'stock-bj-table',
            col:5,
            data:dataArr.filter(v=>v[4]!=32),
            other:data.data,
            padding:20,
            title:{
                html:function(v){
                    if(v.title == '价格'){
                        return `<th style='text-align:right;padding-right:8px;'>${v.title}</th>`
                    }else{
                        return `<th>${v.title}</th>`
                    }
                }
            },
            item:[
                {
                    title:'时间',
                    html:function(v){
                        return '<td>' + v[0] + '</td>'
                    }
                },{
                    title:'买卖方向',
                    html:function(v){
                        var res = ''
                        if(v[1] == 49){
                            res = '买入'
                        }else if(v[1] == 50){
                            res = '卖出'
                        }else if(v[1] == 70){
                            res = '出借'
                        }else if(v[1] == 71){
                            res = '借入'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                },{
                    title:'价格',
                    html:function(v,o){
                        // var color = v[1] == 49 ? 'red' : 'green'
                        // return `<td class='${color}' style='text-align:right;padding-right:4px;'>${v[2]}</td>`;
                        return `<td style='text-align:right;padding-right:4px;'>${v[2]}</td>`;
                    }
                },{
                    title:'数量',
                    html:function(v){
                        return '<td>' + v[3] + '</td>'
                    }
                },{
                    title:'交易方式',
                    html:function(v){
                        var res = ''
                        if(v[4] == 1){
                            res = '匹配成交'
                        }else if(v[4] == 2){
                            res = '协商成交'
                        }else if(v[4] == 4){
                            res = '点击成交'
                        }else if(v[4] == 8){
                            res = '意向申报'
                        }else if(v[4] == 16){
                            res = '询价成交'
                        }else if(v[4] == 32){
                            res = '竞买成交'
                        }else if(v[4] == 64){
                            res = '匹配成交大额'
                        }else{
                            res = '-'
                        }
                        return '<td style="font-size:12px">' + res + '</td>'
                    }
                }
            ]
        }
        var table = new bjTable(data)
        table.init()
    }else if(type == 1){
        // 匹配成交
        var dataArr = []
        $.each(data.data.order, function (i,v) {
            dataArr.push(v.split(','))
        })
        var data = {
            ele:'stock-bj-table',
            col:4,
            data:dataArr,
            other:data.data,
            padding:20,
            title:{
                html:function(v){
                    if(v.title == '价格'){
                        return `<th style='text-align:right;padding-right:12px;'>${v.title}</th>`
                    }else{
                        return `<th>${v.title}</th>`
                    }
                }
            },
            item:[
                {
                    title:'时间',
                    html:function(v){
                        return '<td>' + v[0] + '</td>'
                    }
                },{
                    title:'买卖方向',
                    html:function(v){
                        var res = ''
                        if(v[1] == 49){
                            res = '买入'
                        }else if(v[1] == 50){
                            res = '卖出'
                        }else if(v[1] == 70){
                            res = '出借'
                        }else if(v[1] == 71){
                            res = '借入'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                },{
                    title:'价格',
                    html:function(v,o){
                        // var color = v[1] == 49 ? 'red' : 'green'
                        // return `<td class='${color}' style='text-align:right;padding-right:8px;'>${v[2]}</td>`;
                        return `<td style='text-align:right;padding-right:4px;'>${v[2]}</td>`;
                    }
                },{
                    title:'数量',
                    html:function(v){
                        return '<td>' + v[3] + '</td>'
                    }
                }
            ]
        }
        var table = new bjTable(data)
        table.init()
    }else if(type == 2){
        // 点击成交
        var dataArr = []
        $.each(data.data.order, function (i,v) {
            dataArr.push(v.split(','))
        })
        var data = {
            ele:'stock-bj-table',
            col:4,
            data:dataArr,
            other:data.data,
            padding:20,
            title:{
                html:function(v){
                    if(v.title == '价格'){
                        return `<th style='text-align:right;padding-right:12px;'>${v.title}</th>`
                    }else{
                        return `<th>${v.title}</th>`
                    }
                }
            },
            item:[
                {
                    title:'时间',
                    html:function(v){
                        return '<td>' + v[0] + '</td>'
                    }
                },{
                    title:'买卖方向',
                    html:function(v){
                        var res = ''
                        if(v[1] == 49){
                            res = '买入'
                        }else if(v[1] == 50){
                            res = '卖出'
                        }else if(v[1] == 70){
                            res = '出借'
                        }else if(v[1] == 71){
                            res = '借入'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                },{
                    title:'价格',
                    html:function(v,o){
                        // var color = v[1] == 49 ? 'red' : 'green'
                        // return `<td class='${color}' style='text-align:right;padding-right:8px;'>${v[2]}</td>`;
                        return `<td style='text-align:right;padding-right:4px;'>${v[2]}</td>`;
                    }
                },{
                    title:'数量',
                    html:function(v){
                        return '<td>' + v[3] + '</td>'
                    }
                },{
                    title:'结算方式',
                    html:function(v){
                        var res = ''
                        if(v[4] == 0){
                            res = '不指定'
                        }else if(v[4] == 103){
                            res = '多边净额'
                        }else if(v[4] == 104){
                            res = '逐笔全额'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                },{
                    title:'结算周期',
                    html:function(v){
                        var res = ''
                        if(v[5] == 0){
                            res = 'T+0'
                        }else if(v[5] == 1){
                            res = 'T+1'
                        }else if(v[5] == 2){
                            res = 'T+2'
                        }else if(v[5] == 3){
                            res = 'T+3'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                },{
                    title:'交易商',
                    html:function(v){
                        return '<td>' + v[6] + '</td>'
                    }
                },{
                    title:'交易员',
                    html:function(v){
                        return '<td>' + v[7] + '</td>'
                    }
                }
            ]
        }
        var table = new bjTable(data)
        table.init()
    }else if(type == 3){
        // 意向申报
        var dataArr = []
        $.each(data.data.order, function (i,v) {
            dataArr.push(v.split(','))
        })
        var data = {
            ele:'stock-bj-table',
            col:4,
            data:dataArr,
            other:data.data,
            padding:20,
            title:{
                html:function(v){
                    if(v.title == '价格'){
                        return `<th style='text-align:right;padding-right:12px;'>${v.title}</th>`
                    }else{
                        return `<th>${v.title}</th>`
                    }
                }
            },
            item:[
                {
                    title:'时间',
                    html:function(v){
                        return '<td>' + v[0] + '</td>'
                    }
                },{
                    title:'买卖方向',
                    html:function(v){
                        var res = ''
                        if(v[1] == 49){
                            res = '买入'
                        }else if(v[1] == 50){
                            res = '卖出'
                        }else if(v[1] == 70){
                            res = '出借'
                        }else if(v[1] == 71){
                            res = '借入'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                },{
                    title:'价格',
                    html:function(v,o){
                        // var color = v[1] == 49 ? 'red' : 'green'
                        // return `<td class='${color}' style='text-align:right;padding-right:8px;'>${v[2]}</td>`;
                        return `<td style='text-align:right;padding-right:4px;'>${v[2]}</td>`;
                    }
                },{
                    title:'数量',
                    html:function(v){
                        return '<td>' + v[3] + '</td>'
                    }
                },{
                    title:'结算方式',
                    html:function(v){
                        var res = ''
                        if(v[4] == 0){
                            res = '不指定'
                        }else if(v[4] == 103){
                            res = '多边净额'
                        }else if(v[4] == 104){
                            res = '逐笔全额'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                },{
                    title:'结算周期',
                    html:function(v){
                        var res = ''
                        if(v[5] == 0){
                            res = 'T+0'
                        }else if(v[5] == 1){
                            res = 'T+1'
                        }else if(v[5] == 2){
                            res = 'T+2'
                        }else if(v[5] == 3){
                            res = 'T+3'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                }
            ]
        }
        var table = new bjTable(data)
        table.init()
    }else if(type == 4){
        // 竞买成交
        // var dataArr = []
        // $.each(data.data.order, function (i,v) {
        //     dataArr.push(v.split(','))
        // })
        // var data = {
        //     ele:'stock-bj-table',
        //     col:4,
        //     data:dataArr,
        //     other:data.data,
        //     padding:20,
        //     title:{
        //         html:function(v){
        //             if(v.title == '价格'){
        //                 return `<th style='text-align:right;padding-right:12px;'>${v.title}</th>`
        //             }else{
        //                 return `<th>${v.title}</th>`
        //             }
        //         }
        //     },
        //     item:[
        //         {
        //             title:'竞拍方',
        //             html:function(v){
        //                 return '<td>' + v[3]??"-" + '</td>'
        //             }
        //         },
        //         {
        //             title:'买卖方向',
        //             html:function(v){
        //                 var res = ''
        //                 if(v[0] == 49){
        //                     res = '买入'
        //                 }else if(v[0] == 50){
        //                     res = '卖出'
        //                 }else if(v[0] == 70){
        //                     res = '出借'
        //                 }else if(v[0] == 71){
        //                     res = '借入'
        //                 }else{
        //                     res = '-'
        //                 }
        //                 return '<td>' + res + '</td>'
        //             }
        //         },{
        //             title:'价格',
        //             html:function(v,o){
        //                 var color = v[1] == 49 ? 'red' : 'green'
        //                 return `<td class='${color}' style='text-align:right;padding-right:8px;'>${v[2]}</td>`;
        //             }
        //         },{
        //             title:'数量',
        //             html:function(v){
        //                 return '<td>' + v[2] + '</td>'
        //             }
        //         },
        //     ]
        // }
        // var table = new bjTable(data)
        // table.init()
    }

}

//type: 0:全部成交 1:匹配成交 2:点击成交 3:询价成交 4:协商成交 5:竞买成交
function loadZBCJ(data,type){
    if(type == 0){
        //全部成交
        var dataArr = []
        $.each(data.data.trans, function (i,v) {
            dataArr.push(v.split(','))
        })
        var data = {
            ele:'deal-bj-table',
            col:4,
            data:dataArr.filter(v=>v[3]!=32),
            other:data.data,
            padding:20,
            title:{
                html:function(v){
                    if(v.title == '成交价'){
                        return `<th style='text-align:right;padding-right:8px;'>${v.title}</th>`
                    }else{
                        return `<th>${v.title}</th>`
                    }
                }
            },
            item:[
                {
                    title:'时间',
                    html:function(v){
                        return '<td>' + v[0] + '</td>'
                    }
                },{
                    title:'成交价',
                    html:function(v,o){
                        // var color = v[1] == 49 ? 'red' : 'green'
                        // return `<td class='${color}' style='text-align:right;padding-right:4px;'>${v[1]}</td>`;
                        return `<td style='text-align:right;padding-right:4px;'>${v[1]}</td>`;
                    }
                },{
                    title:'成交量',
                    html:function(v){
                        return '<td>' + v[2] + '</td>'
                    }
                },{
                    title:'交易方式',
                    html:function(v){
                        var res = ''
                        if(v[3] == 1){
                            res = '匹配成交'
                        }else if(v[3] == 2){
                            res = '协商成交'
                        }else if(v[3] == 4){
                            res = '点击成交'
                        }else if(v[3] == 8){
                            res = '意向申报'
                        }else if(v[3] == 16){
                            res = '询价成交'
                        }else if(v[3] == 32){
                            res = '竞买成交'
                        }else if(v[3] == 64){
                            res = '匹配成交大额'
                        }else{
                            res = '-'
                        }
                        return '<td style="font-size:12px">' + res + '</td>'
                    }
                }
            ]
        }
        var table = new bjTable(data)
        table.init()
    }else if(type == 1 || type == 2 || type == 3 || type == 4){
        // 匹配成交
        var dataArr = []
        $.each(data.data.trans, function (i,v) {
            dataArr.push(v.split(','))
        })
        var data = {
            ele:'deal-bj-table',
            col:5,
            data:dataArr,
            other:data.data,
            padding:20,
            title:{
                html:function(v){
                    if(v.title == '成交价'){
                        return `<th style='text-align:right;padding-right:12px;'>${v.title}</th>`
                    }else{
                        return `<th>${v.title}</th>`
                    }
                }
            },
            item:[
                {
                    title:'时间',
                    html:function(v){
                        return '<td>' + v[0] + '</td>'
                    }
                },{
                    title:'成交价',
                    html:function(v,o){
                        // var color = v[1] == 49 ? 'red' : 'green'
                        // return `<td class='${color}' style='text-align:right;padding-right:4px;'>${v[1]}</td>`;
                        return `<td style='text-align:right;padding-right:4px;'>${v[1]}</td>`;
                    }
                },{
                    title:'成交量',
                    html:function(v){
                        return '<td>' + v[2] + '</td>'
                    }
                },{
                    title:'结算方式',
                    html:function(v){
                        var res = ''
                        if(v[3] == 0){
                            res = '不指定'
                        }else if(v[3] == 103){
                            res = '多边净额'
                        }else if(v[3] == 104){
                            res = '逐笔全额'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                },{
                    title:'结算周期',
                    html:function(v){
                        var res = ''
                        if(v[4] == 0){
                            res = 'T+0'
                        }else if(v[4] == 1){
                            res = 'T+1'
                        }else if(v[4] == 2){
                            res = 'T+2'
                        }else if(v[4] == 3){
                            res = 'T+3'
                        }else{
                            res = '-'
                        }
                        return '<td>' + res + '</td>'
                    }
                }
            ]
        }
        var table = new bjTable(data)
        table.init()
    }else if(type == 5){
        // 竞买成交
    }

}

function loadnews(pagenews, type) {
    var tempCode = CODE;
    var tempmk = MK;
    if (MK == 90) {
        //板块特殊处理
        tempCode = tempCode.substr(3, 3);
    }

    if (MK == CHOICE_ZS) {
        tempCode = '000001'
        tempmk = '1'
    }

    stock_info.getStockNewsOrNotice(tempCode, tempmk, type, '', pagenews, 20).then(function (back) {

        var dataa = {
            data: {
                data: {

                }
            }
        }

        //dataa.data = data
        dataa.data.data.items = back.news

        if (type == 2) {
            //公告
            if (dataa.data.data.items.length == 0) {
                $("#js_gg_nodata").show();
                $("#onLoadingUI_gg").hide();
                return false;
            } else if (dataa.data.data.items.length < 20) {
                $("#js_gg_more").hide();
                $("#onLoadingUI_gg").hide();
                $("#js_gg_final").show();
            } else {
                $("#js_gg_more").show();
                $("#onLoadingUI_gg").hide();
            }
            if (pagenotice == 1) {
                if (MK == GG_CODE) {
                    var html = EM.Template('stock_hk_gg', dataa);
                    document.getElementById('ulggContainer').innerHTML = html;
                } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
                    var html = EM.Template('stock_us_gg', dataa);
                    document.getElementById('ulggContainer').innerHTML = html;
                } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
                    var html = EM.Template('stock_hs_gg', dataa);
                    document.getElementById('ulggContainer').innerHTML = html;
                } else if (MK == BK_CODE_NO) {
                    var html = EM.Template('stock_bk_gg', dataa);
                    document.getElementById('ulggContainer').innerHTML = html;
                } else if (iszq()) {
                    var html = EM.Template('stock_zq_gg', dataa);
                    document.getElementById('ulggContainer').innerHTML = html;
                } else {
                    var html = EM.Template('stock_uk_gg', dataa);
                    document.getElementById('ulggContainer').innerHTML = html;
                }
            } else {
                if (MK == GG_CODE) {
                    var html = EM.Template('stock_hk_gg', dataa);
                    $("#ulggContainer").find("li").last().after(html);
                } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
                    var html = EM.Template('stock_us_gg', dataa);
                    $("#ulggContainer").find("li").last().after(html);
                } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
                    var html = EM.Template('stock_hs_gg', dataa);
                    $("#ulggContainer").find("li").last().after(html);
                } else if (MK == BK_CODE_NO) {
                    var html = EM.Template('stock_bk_gg', dataa);
                    $("#ulggContainer").find("li").last().after(html);
                } else if (iszq()) {
                    var html = EM.Template('stock_zq_gg', dataa);
                    $("#ulggContainer").find("li").last().after(html);
                } else {
                    var html = EM.Template('stock_uk_gg', dataa);
                    $("#ulggContainer").find("li").last().after(html);
                }
            }
        } else if (type == 3) {
            //研报
            if (dataa.data.data.items.length == 0) {
                $("#js_yb_nodata").show();
                $("#onLoadingUI_yb").hide();
                return false;
            } else if (dataa.data.data.items.length < 20) {
                $("#js_yb_more").hide();
                $("#onLoadingUI_yb").hide();
                $("#js_yb_final").show();
            } else {
                $("#js_yb_more").show();
                $("#onLoadingUI_yb").hide();
            }

            if (pagenews == 1) {
                if (MK == BK_CODE_NO) {
                    var html = EM.Template('stock_bk_yb', dataa);
                    document.getElementById('ulybContainer').innerHTML = html;
                } else if (isqq()) {
                    var html = EM.Template('stock_qq_yb', dataa);
                    document.getElementById('ulybContainer').innerHTML = html;
                } else {
                    var html = EM.Template('stock_hs_yb', dataa);
                    document.getElementById('ulybContainer').innerHTML = html;
                }
            } else {
                if (MK == BK_CODE_NO) {
                    var html = EM.Template('stock_bk_yb', dataa);
                    $("#ulybContainer").find("li").last().after(html);
                } else if (isqq()) {
                    var html = EM.Template('stock_qq_yb', dataa);
                    $("#ulybContainer").find("li").last().after(html);
                } else {
                    var html = EM.Template('stock_hs_yb', dataa);
                    $("#ulybContainer").find("li").last().after(html);
                }
            }
        } else {
            //新闻
            if (dataa.data.data.items.length == 0) {
                $("#js_xw_nodata").show();
                $("#onLoadingUI_xw").hide();
                return false;
            } else if (dataa.data.data.items.length < 20) {
                $("#js_xw_more").hide();
                $("#onLoadingUI_xw").hide();
                $("#js_xw_final").show();
            } else {
                $("#js_xw_more").show();
                $("#onLoadingUI_xw").hide();
            }

            if (pagenews == 1) {
                if (MK == GG_CODE) {
                    var html = EM.Template('stock_hk_xw', dataa);
                    document.getElementById('ulxwContainer').innerHTML = html;
                } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
                    var html = EM.Template('stock_us_xw', dataa);
                    document.getElementById('ulxwContainer').innerHTML = html;
                } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
                    var html = EM.Template('stock_hs_xw', dataa);
                    document.getElementById('ulxwContainer').innerHTML = html;
                } else if (MK == BK_CODE_NO) {
                    var html = EM.Template('stock_bk_xw', dataa);
                    document.getElementById('ulxwContainer').innerHTML = html;
                } else if (isqq()) {
                    var html = EM.Template('stock_qq_xw', dataa);
                    document.getElementById('ulxwContainer').innerHTML = html;
                } else if (iszq()) {
                    var html = EM.Template('stock_zq_xw', dataa);
                    document.getElementById('ulxwContainer').innerHTML = html;
                } else {
                    var html = EM.Template('stock_uk_xw', dataa);
                    document.getElementById('ulxwContainer').innerHTML = html;
                }
            } else {
                if (MK == GG_CODE) {
                    var html = EM.Template('stock_hk_xw', dataa);
                    $("#ulxwContainer").find("li").last().after(html);
                } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
                    var html = EM.Template('stock_us_xw', dataa);
                    $("#ulxwContainer").find("li").last().after(html);
                } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
                    var html = EM.Template('stock_hs_xw', dataa);
                    $("#ulxwContainer").find("li").last().after(html);
                } else if (MK == BK_CODE_NO) {
                    var html = EM.Template('stock_bk_xw', dataa);
                    $("#ulxwContainer").find("li").last().after(html);
                } else if (isqq()) {
                    var html = EM.Template('stock_qq_xw', dataa);
                    $("#ulxwContainer").find("li").last().after(html);
                } else if (iszq()) {
                    var html = EM.Template('stock_zq_xw', dataa);
                    $("#ulxwContainer").find("li").last().after(html);
                } else {
                    var html = EM.Template('stock_uk_xw', dataa);
                    $("#ulxwContainer").find("li").last().after(html);
                }
            }
        }
    })
        .catch(function (error) {

        })



    return false
    $.ajax({
        type: 'get',
        url: "./getstockinfolist",
        data: {
            code: tempCode,
            market: MK,
            page: pagenews,
            type: type
        },
        dataType: 'json',
        success: function (data) {
            if (!data.re) {
                return false
            }
            // var dataa = [];
            // var jsonObj = data;
            // dataa.data = jsonObj;
            var dataa = {
                data: null
            }
            dataa.data = data.result

            if (type == 2) {
                //公告
                if (dataa.data.data.items.length == 0) {
                    $("#js_gg_nodata").show();
                    $("#onLoadingUI_gg").hide();
                    return false;
                } else if (dataa.data.data.items.length < 20) {
                    $("#js_gg_more").hide();
                    $("#onLoadingUI_gg").hide();
                    $("#js_gg_final").show();
                } else {
                    $("#js_gg_more").show();
                    $("#onLoadingUI_gg").hide();
                }
                if (pagenotice == 1) {
                    if (MK == GG_CODE) {
                        var html = EM.Template('stock_hk_gg', dataa);
                        document.getElementById('ulggContainer').innerHTML = html;
                    } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
                        var html = EM.Template('stock_us_gg', dataa);
                        document.getElementById('ulggContainer').innerHTML = html;
                    } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
                        var html = EM.Template('stock_hs_gg', dataa);
                        document.getElementById('ulggContainer').innerHTML = html;
                    } else if (MK == BK_CODE_NO) {
                        var html = EM.Template('stock_bk_gg', dataa);
                        document.getElementById('ulggContainer').innerHTML = html;
                    } else if (iszq()) {
                        var html = EM.Template('stock_zq_gg', dataa);
                        document.getElementById('ulggContainer').innerHTML = html;
                    } else {
                        var html = EM.Template('stock_uk_gg', dataa);
                        document.getElementById('ulggContainer').innerHTML = html;
                    }
                } else {
                    if (MK == GG_CODE) {
                        var html = EM.Template('stock_hk_gg', dataa);
                        $("#ulggContainer").find("li").last().after(html);
                    } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
                        var html = EM.Template('stock_us_gg', dataa);
                        $("#ulggContainer").find("li").last().after(html);
                    } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
                        var html = EM.Template('stock_hs_gg', dataa);
                        $("#ulggContainer").find("li").last().after(html);
                    } else if (MK == BK_CODE_NO) {
                        var html = EM.Template('stock_bk_gg', dataa);
                        $("#ulggContainer").find("li").last().after(html);
                    } else if (iszq()) {
                        var html = EM.Template('stock_zq_gg', dataa);
                        $("#ulggContainer").find("li").last().after(html);
                    } else {
                        var html = EM.Template('stock_uk_gg', dataa);
                        $("#ulggContainer").find("li").last().after(html);
                    }
                }
            } else if (type == 3) {
                //研报
                if (dataa.data.data.items.length == 0) {
                    $("#js_yb_nodata").show();
                    $("#onLoadingUI_yb").hide();
                    return false;
                } else if (dataa.data.data.items.length < 20) {
                    $("#js_yb_more").hide();
                    $("#onLoadingUI_yb").hide();
                    $("#js_yb_final").show();
                } else {
                    $("#js_yb_more").show();
                    $("#onLoadingUI_yb").hide();
                }

                if (pagenews == 1) {
                    if (MK == BK_CODE_NO) {
                        var html = EM.Template('stock_bk_yb', dataa);
                        document.getElementById('ulybContainer').innerHTML = html;
                    } else if (isqq()) {
                        var html = EM.Template('stock_qq_yb', dataa);
                        document.getElementById('ulybContainer').innerHTML = html;
                    } else {
                        var html = EM.Template('stock_hs_yb', dataa);
                        document.getElementById('ulybContainer').innerHTML = html;
                    }
                } else {
                    if (MK == BK_CODE_NO) {
                        var html = EM.Template('stock_bk_yb', dataa);
                        $("#ulybContainer").find("li").last().after(html);
                    } else if (isqq()) {
                        var html = EM.Template('stock_qq_yb', dataa);
                        $("#ulybContainer").find("li").last().after(html);
                    } else {
                        var html = EM.Template('stock_hs_yb', dataa);
                        $("#ulybContainer").find("li").last().after(html);
                    }
                }
            } else {
                //新闻
                if (dataa.data.data.items.length == 0) {
                    $("#js_xw_nodata").show();
                    $("#onLoadingUI_xw").hide();
                    return false;
                } else if (dataa.data.data.items.length < 20) {
                    $("#js_xw_more").hide();
                    $("#onLoadingUI_xw").hide();
                    $("#js_xw_final").show();
                } else {
                    $("#js_xw_more").show();
                    $("#onLoadingUI_xw").hide();
                }

                if (pagenews == 1) {
                    if (MK == GG_CODE) {
                        var html = EM.Template('stock_hk_xw', dataa);
                        document.getElementById('ulxwContainer').innerHTML = html;
                    } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
                        var html = EM.Template('stock_us_xw', dataa);
                        document.getElementById('ulxwContainer').innerHTML = html;
                    } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
                        var html = EM.Template('stock_hs_xw', dataa);
                        document.getElementById('ulxwContainer').innerHTML = html;
                    } else if (MK == BK_CODE_NO) {
                        var html = EM.Template('stock_bk_xw', dataa);
                        document.getElementById('ulxwContainer').innerHTML = html;
                    } else if (isqq()) {
                        var html = EM.Template('stock_qq_xw', dataa);
                        document.getElementById('ulxwContainer').innerHTML = html;
                    } else if (iszq()) {
                        var html = EM.Template('stock_zq_xw', dataa);
                        document.getElementById('ulxwContainer').innerHTML = html;
                    } else {
                        var html = EM.Template('stock_uk_xw', dataa);
                        document.getElementById('ulxwContainer').innerHTML = html;
                    }
                } else {
                    if (MK == GG_CODE) {
                        var html = EM.Template('stock_hk_xw', dataa);
                        $("#ulxwContainer").find("li").last().after(html);
                    } else if (MK == MG_CODE_MJ || MK == MG_CODE_NJ || MK == MG_CODE_NS || MK == FD_CODE) {
                        var html = EM.Template('stock_us_xw', dataa);
                        $("#ulxwContainer").find("li").last().after(html);
                    } else if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
                        var html = EM.Template('stock_hs_xw', dataa);
                        $("#ulxwContainer").find("li").last().after(html);
                    } else if (MK == BK_CODE_NO) {
                        var html = EM.Template('stock_bk_xw', dataa);
                        $("#ulxwContainer").find("li").last().after(html);
                    } else if (isqq()) {
                        var html = EM.Template('stock_qq_xw', dataa);
                        $("#ulxwContainer").find("li").last().after(html);
                    } else if (iszq()) {
                        var html = EM.Template('stock_zq_xw', dataa);
                        $("#ulxwContainer").find("li").last().after(html);
                    } else {
                        var html = EM.Template('stock_uk_xw', dataa);
                        $("#ulxwContainer").find("li").last().after(html);
                    }
                }
            }
        },
        error: function (err) {
            if (type == 2) {
                //公告
                $("#js_gg_nodata").show();
                $("#onLoadingUI_gg").hide();
            } else if (type == 3) {
                //研报
                $("#js_yb_nodata").show();
                $("#onLoadingUI_yb").hide();

            } else {
                //新闻
                $("#js_xw_nodata").show();
                $("#onLoadingUI_xw").hide();

            }
        }
    })
}

function _loadnews(pagenews,type){
    var tempCode = CODE;
    var tempmk = MK;
    
    if (MK == 90 && type != 0) {
        //板块特殊处理
        tempCode = Number(tempCode.substr(2, 4)).toString();
    }

    if(MK == CHOICE_ZS){
        tempCode = '000001'
        tempmk = '1'
    }


    stock_info_new.getStockNewsOrNotice(tempCode, tempmk, type, pagenews, 20 , MK==90).then(function(back){
        var dataa = {
            data: {
                data:{
    
                }
            }
        }
        
        dataa.data.data.items = back
        if (type == 1) {
            //研报
            if (dataa.data.data.items.length == 0) {
                $("#js_yb_nodata").show();
                $("#onLoadingUI_yb").hide();
                return false;
            } else if (dataa.data.data.items.length < 20) {
                $("#js_yb_more").hide();
                $("#onLoadingUI_yb").hide();
                $("#js_yb_final").show();
            } else {
                $("#js_yb_more").show();
                $("#onLoadingUI_yb").hide();
            }

            if (pagenews == 1) {
                var html = EM.Template('stock_yb_new', dataa);
                document.getElementById('ulybContainer').innerHTML = html;
            } else {
                var html = EM.Template('stock_yb_new', dataa);
                $("#ulybContainer").find("li").last().after(html);
            }
        }else if (type == 2) {
            //公告
            if (dataa.data.data.items.length == 0) {
                $("#js_gg_nodata").show();
                $("#onLoadingUI_gg").hide();
                return false;
            } else if (dataa.data.data.items.length < 20) {
                $("#js_gg_more").hide();
                $("#onLoadingUI_gg").hide();
                $("#js_gg_final").show();
            } else {
                $("#js_gg_more").show();
                $("#onLoadingUI_gg").hide();
            }
            if (pagenotice == 1) {
                var html = EM.Template('stock_gg_new', dataa);
                document.getElementById('ulggContainer').innerHTML = html;
            } else {
                var html = EM.Template('stock_gg_new', dataa);
                $("#ulggContainer").find("li").last().after(html);
            }
        }else{
            //新闻
            if (dataa.data.data.items.length == 0) {
                $("#js_xw_nodata").show();
                $("#onLoadingUI_xw").hide();
                return false;
            } else if (dataa.data.data.items.length < 20) {
                $("#js_xw_more").hide();
                $("#onLoadingUI_xw").hide();
                $("#js_xw_final").show();
            } else {
                $("#js_xw_more").show();
                $("#onLoadingUI_xw").hide();
            }

            if (pagenews == 1) {
                var html = EM.Template('stock_xw_new', dataa);
                document.getElementById('ulxwContainer').innerHTML = html;
            } else {
                var html = EM.Template('stock_xw_new', dataa);
                $("#ulxwContainer").find("li").last().after(html);
            }
        }
    }).catch(function(error){
      
    })
}

function calclogo(code) {
    var str = [];
    if (code == null || code == "" || code == "-") {
        return str;
    }

    if (parseInt(code) & 64) {
        str.push("融");
    }

    if (parseInt(code) & 128) {
        str.push("港股通");
    }

    if (parseInt(code) & 256) {
        if (str.indexOf("港股通") < 0) {
            str.push("港股通");
        }
    }

    if (parseInt(code) & 512) {
        str.push("沪港通");
    }

    if (parseInt(code) & 1024) {
        str.push("深港通");
    }

    return str;
    //1	默认
    //2	退市
    //4	风险警示
    //8	已上市新股
    //16	未上市新股
    //32	暂停上市
    //64	融资融券
    //128	港股通(沪)
    //256	港股通(深)
    //512	沪股通
    //1024	深股通
}

function loadAHData(data){
    let price = formartDataNew(data.f251,data.f255,data.f255),
        precent = formartDataNew(data.f252,data.f152,data.f152),
        comparison = formartDataNew(data.f254,data.f152,data.f152),
        color = precent > 0 ? 'red' : 'green',
        _color = '',
        tit1 = '',
        tit2 = '';
    if(MK == GG_CODE){
        // 港股
        tit1 = 'A股报价：';
        tit2 = '(A/H)比价=';
    }else{
        // A股
        comparison = formartDataNew(1/comparison*Math.pow(10,data.f152),data.f152,data.f152);
        tit1 = 'H股报价：'
        tit2 = '(H/A)比价=';
    }
    _color = comparison > 1 ? 'red' : 'green';
    precent = precent > 0 ? `${precent}%` : (precent < 0 ? `${precent}%` : '0.00%')
    let html = `
    <p>
        ${tit1}
        <span class="${color}">${price}&nbsp;&nbsp;${precent}</span>
    </p>
    <p>
        <i class="icon-question"></i>
        ${tit2}<span class="${_color}">${comparison}</span>
        <i class="arrow-right-new"></i>
    </p>`
    $('.ah-notice').show();
    $('.ah-container').html(html);
    $('.ah-container').click(function(){
        window.location.href = `/quote/stock/${data.f257}.${data.f256}.html`;
    })
    $('.icon-question').click(function(){
        window.location.href = `/quote/ahdescription.html`;
        event.stopPropagation(); 
    })

}

function goAhDetail(){
    window.location.href = '/quote/ahdescription.html';
}
window.goAhDetail = goAhDetail

//加自选
$("#addstock_btn").on('click', function () {
    // 显示弹窗 只有沪深、港股打开APP
    $('.zx-pop').show();
    $('.zx-layer').show();
})

$('#zx-cancel').on('click',function(){
    addStock();
    $('.zx-layer').hide();
    $('.zx-pop').hide();
    try {
        // 大数据埋点
        window.sendTrackLog('div','click','ggxqy_djzxcfdc_qx')
    } catch (error) {
        
    }
})

$('#zx-goapp').on('click',function(){
    goAppClick('zx');
    $('.zx-layer').hide();
    $('.zx-pop').hide();
    try {
        // 大数据埋点
        window.sendTrackLog('div','click','ggxqy_djzxcfdc_tzapp')
    } catch (error) {
        
    }
})

$('#openinapp').on('click',function(){
    goAppClick('page');
    try {
        // 大数据埋点
        window.sendTrackLog('div','click','ggxqy_fb_tzapp')
    } catch (error) {
        
    }
})

$('.stock-bj-loadmore').on('click',function(){
    if($('.stock-bj-loadmore').html() !== '已经到底了'){
        bjlmtArr[bjOptions.navtype - 1][bjOptions.tabletype] += 10
        loadBJ(MK,CODE,bjOptions.navtype,bjOptions.tabletype);
    }else{
        console.log('已经到底了')
    }
})

function addStock(){
    newzxg.addDefaultStock(stock_market + '.' + stock_code).then(function(back){
        if(back.re){
          $("#addstock_btn").hide();
          $('#deletestock_btn').show()
        }
        else{
            alert(back.message)
        }
      }).catch(function(){
        
    })
}

//指数不能添加自选，关闭弹窗
function canceladdstock() {
    $("#pop-mask").hide();
    $("#popup-602").hide();
}
window.canceladdstock = canceladdstock

//删除自选
$("#deletestock_btn").on('click', function () {
    $(".more-operate-pop").hide();
    newzxg.deleteDefaultStock(stock_market + '.' + stock_code).then(function(back){
      if(back.re){
        $("#deletestock_btn").hide()
        $("#addstock_btn").show();
      }
      else{
          alert(back.message)
      }
    })
    return false
    // var mktemp = "";
    // if (MK == HS_CODE_HS || MK == CHOICE_ZS) {
    //     mktemp = "01";
    // } else if (MK == HS_CODE_SS) {
    //     mktemp = "02";
    // }
    // $.ajax({
    //     type: "get",
    //     url: "https://myfavor.eastmoney.com/mystock_wap?f=dsz&sc=" + CODE + "|" + mktemp + "|01&cb=?",
    //     dataType: "jsonp",
    //     success: function (data) {
    //         dmyselect(data)
    //     }
    // })
})

function formartDataNew(value, rate, digit){
    if(value == null){
        return "--"
    }
    var num = Number(value);
    var r = Number(rate);
    var temp = 1;
    if (r && r > 0) {
        for (var a = 0; a < r; a++) {
            temp = temp * 10;
        }
    }
    else {
        for (var a = 0; a < r; a++) {
            temp = temp / 10;
        }
    }
    if (num) {
        return (num / temp).toFixed(digit)
    }
    return value;
}

function formartColorNew (value, value1) {
    if (value == null || value == "-" || value1 == null || value1 == "-") {
        return "";
    }

    if (value.toString() == "0" || value.toString() == "0.0" || value.toString() == "0.00" || value.toString() == "0.000" || value.toString() == "0.0000") {
        return "gray";
    }

    if (parseFloat(value) > parseFloat(value1)) {
        return "red";
    } else if (parseFloat(value) < parseFloat(value1)) {
        return "green";
    } else {
        return "";
    }
}

function formartUnit(value, unit, point, singlenp) {
    //singlenp:1个位数时不需要保留小数位
    if (value == null || value == "-" || value == "0") {
        if (value != null && value != '-' && unit != 'calc') {
            return value + unit;
        } else {
            return value;
        }
    }
    if (point == '' || point == null || point == undefined || point == 'undefined') {
        point == 2;
    }
    if (unit == "calc") {
        var temp = Number(value);
        if (parseInt(temp) < 10000) {
            if (temp.toFixed(2) == 0.00) {
                return 0;
            } else {
                if (singlenp == 1) {
                    return temp
                } else {
                    return temp.toFixed(point);
                }
            }
        } else if (parseInt(temp) > 999999999999) {
            return (parseFloat(temp) * 1.0 / 1000000000000).toFixed(point) + "万亿";
        } else if (parseInt(temp) > 99999999) {
            return (parseFloat(temp) * 1.0 / 100000000).toFixed(point) + "亿";
        } else {
            return (parseFloat(temp) * 1.0 / 10000).toFixed(point) + "万";
        }
    } else {
        return value + unit;
    }
}



function formartData(value, rate, digit) {
    if(value == null){
        return "--"
    }
    var num = Number(value);
    var r = Number(rate);
    var temp = 1;
    if (r && r > 0) {
        for (var a = 0; a < r; a++) {
            temp = temp * 10;
        }
    }
    else {
        for (var a = 0; a < r; a++) {
            temp = temp / 10;
        }
    }
    if (num) {
        return (num / temp).toFixed(digit)
    }
    return value;
}

function formatAffix(value, prefix,postfix) {
    if (value != null && value != undefined) {
        if(value > 0){
            return prefix + value + postfix
        }else if(value == 0){
            return "0.00" + postfix
        }else{
            return value + postfix
        }
    }
}
// function initmyselect(json) {
//     if (json != null && json.result == "1") {
//         var data = json.data.order;
//         var arr = data.split(',');
//         if (arr.length > 0) {
//             for (var i = 0; i < arr.length; i++) {
//                 if (arr[i].split('|')[0] == CODE) {
//                     //$("#more_btn").show();
//                     $("#deletestock_btn").show()
//                     $("#addstock_btn").hide();
//                     break;
//                 } else {
//                     //$("#more_btn").hide();
//                     $("#deletestock_btn").hide()
//                     $("#addstock_btn").show();
//                 }
//             }
//         }
//     }
// }

// function dmyselect(json) {
//     if (json != null && json.result == "1") {
//         //初始化自选
//         $.ajax({
//             type: "get",
//             url: "https://myfavor.eastmoney.com/mystock_wap?f=gsz&cb=?",
//             dataType: "jsonp",
//             success: function (data) {
//                 initmyselect(data)
//             }
//         })
//     }
// }

function closemyselect() {
    $(".more-operate-pop").hide();
}

window.closemyselect = closemyselect

function myselect(json) {
}



$("#btn-set-alarm").click(function () {
    $("#pop-mask").show();
    $("#popup-526").show();
})

//取消自选
$("#more_btn").click(function () {
    $(".more-operate-pop").show();
})
//取消设置提醒
function closemyremind() {
    $("#pop-mask").hide();
    $("#popup-526").hide();
}

window.closemyremind = closemyremind

function sendtip() {
    var oldurl = location.href;
    location.href = "http://mguba.eastmoney.com/mguba/newpost/" + gubaCodeChange(CODE) + "/" + encodeURIComponent(oldurl);
}

window.sendtip = sendtip

window.cdtimer = null


function refresh() {
    // var self = this;
    try {
        if (window.cdtimer)
            clearInterval(window.cdtimer);        
    } catch (error) {
        
    }

    if (quotaConfig.refreshDuration) {

        if(window.stock_market == '116'){ //港股不登陆或者海外不刷新
            hk_rule.isDelayCache().then(function(back){
                if(!back.re){
                    window.cdtimer = setInterval(function () {
                        loadTopHq();
                    }, quotaConfig.refreshDuration);                      
                }
            })
        }
        else{
            window.cdtimer = setInterval(function () {
                loadTopHq();
            }, quotaConfig.refreshDuration);            
        }


    }
}

function returnTransactionMode(val){
    var res = ''
    if(val == 1){
        res = '匹配成交'
    }else if(val == 2){
        res = '协商成交'
    }else if(val == 4){
        res = '点击成交'
    }else if(val == 8){
        res = '意向申报'
    }else if(val == 16){
        res = '询价成交'
    }else if(val == 32){
        res = '竞买成交'
    }else if(val == 64){
        res = '匹配成交大额'
    }else{
        res = '-'
    }
    return res
}


//初始化标头
function initialmenu() {
    if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) { //沪深，指数，债券
        $("#indexbox").show();//最底部指数浮层
        if (iszs()) {
            $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
                if ($(this).data('tab') == 'zl') {
                    $(this).hide();
                }
                if ($(this).data('tab') == 'cw') {
                    $(this).hide();
                }
                if ($(this).data('tab') == 'cfg') {
                    $(this).hide();
                }
                if ($(this).data('tab') == 'yb') {
                    $(this).hide();
                }
                //非沪指资金模块不可见
                if (MK == 0) {
                    if ($(this).data('tab') == 'zj') {
                        $(this).hide();
                    }
                }
            })
        } else {
            // bond 如果符合 1-深交所债券、2-深交所质押回购、3-上交所债券、4-上交所质押回购，则显示报价签
            var json = JSON.parse(sessionStorage.getItem("data")),bond = false;
            if(json){
                bond = isBond(json.data.f107,json.data.f111,json.data.f182);
            }
            if(bond){
                $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
                    if ($(this).data('tab') == 'cw') {
                        $(this).hide();
                    }
                })
            }
            if (bond == 1 && json.data.f182 != 11){
                $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
                    if ($(this).data('tab') == 'cfg' || $(this).data('tab') == 'zj' || $(this).data('tab') == 'yb'|| $(this).data('tab') == 'cw') {
                        $(this).hide();
                    }
                    if ($(this).data('tab') == 'bj'){
                        $(this).show()
                    }
                })
            }else if(bond == 4){
                var html_top = EM.Template('stock_hk_top_hq1', json); // stock_hk_top_hq1 为1当行情
                document.getElementById('content_hq').innerHTML = html_top;
                var html_bottom = EM.Template('stock_zq_right_tlp', json);
                document.getElementById('stock_uk_right').innerHTML = html_bottom;
                isRefresh = true
            }

            if (iszq()) {
                $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
                    if ($(this).data('tab') == 'cfg' || $(this).data('tab') == 'zj' || $(this).data('tab') == 'yb'|| $(this).data('tab') == 'cw') {
                        $(this).hide();
                    }
                })
            } else {
                if (CODE.substr(0, 1) != '6' && CODE.substr(0, 1) != '0' && CODE.substr(0, 1) != '3') {
                    //沪深加载
                    $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
                        if ($(this).data('tab') == 'cfg' || $(this).data('tab') == 'zj' || $(this).data('tab') == 'yb') {
                            $(this).hide();
                        }
                    })
                } else {
                    //沪深加载
                    $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
                        if ($(this).data('tab') == 'cfg') {
                            $(this).hide();
                        }
                    })
                }
            }
        }
        loadZsData('000001', '1', '');
    } else if (MK == GG_CODE) {
        $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
            if ($(this).data('tab') == 'cfg' || $(this).data('tab') == 'yb' || $(this).data('tab') == 'zj' || $(this).data('tab') == 'cw') {
                $(this).hide();
            }
        })

        $.each($("#chartTab li"), function (i) {
            if ($(this).text().replace(/(^\s*)|(\s*$)/g, "") == "五日") {
                $(this).hide();
            }
        })
    } else if (MK == ZS_CODE_YB || MK == QIHUO_ZS || MK == ZS_CODE_OTHER || MK == ZS_CODE_OTHER1) {
        $.each($("#stock-infos-tabs").find('li'), function (i) {
            if ($(this).data('tab') == 'gb') {
                $(this).show();
                $(this).css("text-align", "left");
                $(this).css("margin-left", "10px");
            } else {
                $(this).hide();
            }
        })

        $.each($("#chartTab li"), function (i) {
            if ($(this).text().replace(/(^\s*)|(\s*$)/g, "") == "五日" || $(this).attr("imgt") == null) {
                $(this).hide();
            }
        })
    } else if (MK == BK_CODE_NO) {
        $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
            if ($(this).data('tab') == 'zl' || $(this).data('tab') == 'zj' || $(this).data('tab') == 'cw') {
                $(this).hide();
            }
        })
    } else if (isqh() || iswh() || ishj() || isyy()) {
        $.each($("#stock-infos-tabs").find('li'), function (i) {
            if ($(this).data('tab') == 'cfg' || $(this).data('tab') == 'zl' || $(this).data('tab') == 'cw' || $(this).data('tab') == 'zj' || $(this).data('tab') == 'gg' || $(this).data('tab') == 'yb' || $(this).data('tab') == 'xw') {
                $(this).hide();
            } else {
                $(this).css("text-align", "left");
                $(this).css("margin-left", "10px");
            }
        })
        $.each($("#chartTab li"), function (i) {
            if ($(this).text().replace(/(^\s*)|(\s*$)/g, "") == "五日" || $(this).attr("imgt") == null) {
                $(this).hide();
            }
        })

        if (MK == "113") {
            //特殊处理，这类原油需要展示上证指数和自选
            $("#indexbox").show();//最底部指数浮层
            loadZsData('000001', '1', 'first');
        }
    } else if (isqq()) {
        $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
            if ($(this).data('tab') == 'cfg' || $(this).data('tab') == 'zj' || $(this).data('tab') == 'gg' || $(this).data('tab') == 'zl' || $(this).data('tab') == 'cw') {
                $(this).hide();
            }
        })
        $.each($("#chartTab li"), function (i) {
            if ($(this).text().replace(/(^\s*)|(\s*$)/g, "") == "五日" || $(this).attr("imgt") == null) {
                $(this).hide();
            }
        })
    } else {
        $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
            if ($(this).data('tab') == 'cfg' || $(this).data('tab') == 'zj' || $(this).data('tab') == 'yb'|| $(this).data('tab') == 'cw') {
                $(this).hide();
            }
        })

        $.each($("#chartTab li"), function (i) {
            if ($(this).text().replace(/(^\s*)|(\s*$)/g, "") == "五日" || $(this).attr("imgt") == null) {
                $(this).hide();
            }
        })
    }

    var json = JSON.parse(sessionStorage.getItem("data")),bond = false;
    if(json){
        bond = isBond(json.data.f107,json.data.f111,json.data.f182);
    }

    if (MK == BK_CODE_NO) {
        $.each($("#stock-infos-tabs,#stock-infos-list").find('li'), function (i) {
            if ($(this).data('tab') == 'cfg') {
                $(this).addClass("active");
            }
        })
        loadCfgHq();
    } else if(bond == 1 && json.data.f182 != 11){
        $.each($("#stock-infos-tabs").find('li'), function (i) {
            if ($(this).data('tab') == 'bj') {
                $(this).addClass("active");
            }
        })
	
        $.each($("#stock-infos-list").find('li'), function (i) {
            if ($(this).data('tab') == 'bj') {
                $(this).addClass("active");
                bjOptions.navtype = 1;
                bjOptions.tabletype = 0;
                loadBJ(MK,CODE,1,0);
            }
        })
    } else {
        $.each($("#stock-infos-tabs").find('li'), function (i) {
            if ($(this).data('tab') == 'gb') {
                $(this).addClass("active");
            }
        })
	
        $.each($("#stock-infos-list").find('li'), function (i) {
            if ($(this).data('tab') == 'gb') {
                $(this).addClass("active");
                loadGb(MK,CODE)
            }
        })
        
    }

    // $.each($("#ulSwitchHot,#ulGubaSortSelector").find('li'), function (i) {
    //     if ($(this).text() == "热帖" || $(this).text() == "发帖时间排序" || $(this).text() == "评论时间排序") {
    //        $(this).show();
    //    }

    //    if ($(this).text() == "全部") {
    //        $(this).show();
    //        $(this).addClass("active");
    //    }
    //})

    // if (MK == HS_CODE_HS || MK == HS_CODE_SS || MK == CHOICE_ZS) {
    //     if (!iszs()) {
    //         //初始化自选
    //         $.ajax({
    //             type: "get",
    //             url: "https://myfavor.eastmoney.com/mystock_wap?f=gsz&cb=?",
    //             dataType: "jsonp",
    //             success: function (data) {
    //                 initmyselect(data)
    //             }
    //         })
    //     }
    // }
}

//初始化行情图
function initChart(){
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
        setTimeout(function () {
            drawTimeChart("T1")
        }, 1100);
    } else {
        drawTimeChart("T1")
    }
    
    if(window.stock_market == '116'){  //港股不登陆或者海外不刷新
        hk_rule.isDelayCache().then(function(back){
            if(!back.re){
                setInterval(function () {
                    if (chart_type == 'T1' || chart_type == 'T5') {
                        drawTimeChart(chart_type)
                    }
                }, 60000)
            }
        })
    }
    else{
        setInterval(function () {
            if (chart_type == 'T1' || chart_type == 'T5') {
                drawTimeChart(chart_type)
            }
        }, 60000)
    }

    

}

var page = 1,
    page1 = 1,
    pagenews = 1,
    pagenotice = 1,
    pageyb = 1,
    pagecfg = 1,
    cfgsortdir = 1,//降序
    cfgsortseg = 'f2';
//执行初始化加载
$(async function () {
    document.body.style.paddingBottom = '5rem'
    checkIP();
    tempRegister();
    // let _market = getMarketSource();
    // // 若为深交所非可转债，渲染日K tab 
    // if((_market.f107 == 0) &&((_market.f111 == 8))&& (_market.f182 !== 14)){
    //     if(_market.f182 !== 11){
    //         $("#chartTab li").removeClass()
    //         $("#DK-sz").addClass("active")
    //     }
    // }
    chartTabEvent();
    loadTopHq();
    // 初始化表头、行情图加载，债券需求变动需要根据接口返回数据判断是否添加报价签、以及右侧盘口，所以调用放在hqCall内
    // initialmenu();
    // initChart();
    setTimeout(function(){
        // 一个窗口只能自动唤起APP一次
        if(!sessionStorage.getItem('isAutoApp')){
            sessionStorage.setItem('isAutoApp',true)
            goAppAuto()
        }
    },1000)
})
